webpackJsonp([1],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactiveDao = __webpack_require__(86);

var _reactiveDao2 = _interopRequireDefault(_reactiveDao);

var _reactiveDaoSockjs = __webpack_require__(254);

var _reactiveDaoSockjs2 = _interopRequireDefault(_reactiveDaoSockjs);

var _vue = __webpack_require__(27);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.rd = _reactiveDao2.default;

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

var sessionId = localStorage.sessionId;
if (!sessionId) {
  sessionId = guid();
  localStorage.sessionId = sessionId;
}

var api = new _reactiveDao2.default(sessionId, {

  remoteUrl: document.location.protocol + '//' + document.location.host + "/sockjs",

  protocols: {
    'sockjs': _reactiveDaoSockjs2.default
  },

  emailPassword: {
    type: "remote",
    generator: _reactiveDao2.default.ObservableValue
  },
  session: {
    type: "remote",
    generator: _reactiveDao2.default.ObservableValue
  },
  userAdmin: {
    type: "remote",
    generator: function generator(value, what) {
      console.log("REQUEST GENERATOR", what);
      if (what[0] == 'userAdmin' && what[1] == 'usersList') return new _reactiveDao2.default.ObservableList(value);
      return new _reactiveDao2.default.ObservableValue(value);
    }
  },
  subscription: {
    type: "remote",
    generator: _reactiveDao2.default.ObservableValue
  },
  logs: {
    type: "remote",
    generator: _reactiveDao2.default.ObservableList
  },
  config: {
    type: "remote",
    generator: _reactiveDao2.default.ObservableList
  }

});

api.session = new _vue2.default({
  data: {
    session: null
  },
  computed: {
    loggedIn: function loggedIn() {
      return this.session && !!this.session.userId;
    },
    roles: function roles() {
      return this.session && this.session.roles || [];
    }
  },
  watch: {
    session: function session(sess) {
      document.querySelector("#preconnect").style.display = sess != null ? "none" : "flex";
    }
  },
  created: function created() {
    api.observable(["session", "currentSession"]).bindProperty(this, 'session');
  }
});

exports.default = api;

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(27);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(426);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vueMeta = __webpack_require__(425);

var _vueMeta2 = _interopRequireDefault(_vueMeta);

var _Users = __webpack_require__(397);

var _Users2 = _interopRequireDefault(_Users);

var _User = __webpack_require__(396);

var _User2 = _interopRequireDefault(_User);

var _Logs = __webpack_require__(395);

var _Logs2 = _interopRequireDefault(_Logs);

var _Log = __webpack_require__(394);

var _Log2 = _interopRequireDefault(_Log);

var _InputFields = __webpack_require__(392);

var _InputFields2 = _interopRequireDefault(_InputFields);

var _InputLanguage = __webpack_require__(393);

var _InputLanguage2 = _interopRequireDefault(_InputLanguage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vueMeta2.default);

exports.default = new _vueRouter2.default({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'index',
    redirect: { name: 'users' }
  }, {
    path: '/users',
    name: 'users',
    component: _Users2.default
  }, {
    path: '/user/:userId',
    name: 'user',
    component: _User2.default
  }, {
    path: '/logs',
    name: 'logs',
    component: _Logs2.default
  }, {
    path: '/log/:logId',
    name: 'log',
    component: _Log2.default
  }, {
    path: '/inputFields',
    name: 'inputFields',
    component: _InputFields2.default
  }, {
    path: '/inputLanguage/:name',
    name: 'inputLanguage',
    component: _InputLanguage2.default
  }]
});

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(347)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(411),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(10);

var _api2 = _interopRequireDefault(_api);

var _LoginForm = __webpack_require__(401);

var _LoginForm2 = _interopRequireDefault(_LoginForm);

var _overlayLayer = __webpack_require__(32);

var _overlayModel2 = __webpack_require__(33);

var _overlayModel3 = _interopRequireDefault(_overlayModel2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var drawerFocusLostListener = void 0;

exports.default = {
  name: 'app',
  metaInfo: {
    title: 'Semgregate',
    titleTemplate: '%s | Semgregate'
  },
  components: {
    LoginForm: _LoginForm2.default, OverlayComponent: _overlayLayer.OverlayComponent
  },
  data: function data() {
    return {
      drawerVisible: false
    };
  },

  computed: {
    title: function title() {
      var title = this.$route.name;
      try {
        title = app.$route.matched[0].components.default.metaInfo.title;
      } catch (e) {}
      return title;
    },
    loggedIn: function loggedIn() {
      return _api2.default.session.loggedIn;
    },
    overlayModel: function overlayModel() {
      return _overlayModel3.default;
    }
  },
  methods: {
    showDrawer: function showDrawer() {
      this.drawerVisible = !this.drawerVisible;
    },
    logout: function logout() {
      _api2.default.request(["session", "logout"], {});
    }
  },
  watch: {
    drawerVisible: function drawerVisible(visible) {
      var _this = this;

      if (drawerFocusLostListener) document.body.removeEventListener("touch", drawerFocusLostListener);
      if (drawerFocusLostListener) document.body.removeEventListener("click", drawerFocusLostListener);
      if (visible) {
        drawerFocusLostListener = function drawerFocusLostListener(ev) {
          var tg = ev.target;
          while (tg) {
            if (tg.getAttribute('id') == 'main-drawer') return;
            tg = tg.parentElement;
          }
          _this.drawerVisible = false;
        };
      }
      if (drawerFocusLostListener) document.body.addEventListener("touch", drawerFocusLostListener, true);
      if (drawerFocusLostListener) document.body.addEventListener("click", drawerFocusLostListener, true);
    }
  },
  created: function created() {
    window.app = this;
  },
  mounted: function mounted() {
    document.querySelector("#preload").style.display = "none";
  },
  beforeDestroy: function beforeDestroy() {
    if (drawerFocusLostListener) document.body.removeEventListener("touch", drawerFocusLostListener);
    if (drawerFocusLostListener) document.body.removeEventListener("click", drawerFocusLostListener);
  }
};

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InputLanguages = __webpack_require__(399);

var _InputLanguages2 = _interopRequireDefault(_InputLanguages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "InputFields",
  components: { InputLanguages: _InputLanguages2.default }

};

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _set = __webpack_require__(60);

var _set2 = _interopRequireDefault(_set);

var _from = __webpack_require__(57);

var _from2 = _interopRequireDefault(_from);

var _api = __webpack_require__(10);

var _api2 = _interopRequireDefault(_api);

var _initData = __webpack_require__(89);

var _initData2 = _interopRequireDefault(_initData);

var _ColumnTranslation = __webpack_require__(398);

var _ColumnTranslation2 = _interopRequireDefault(_ColumnTranslation);

var _SummaryRegex = __webpack_require__(400);

var _SummaryRegex2 = _interopRequireDefault(_SummaryRegex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var translationTargets = {
  adPerformance: (0, _from2.default)(new _set2.default(_initData2.default.adPerformance.columnTranslation.map(function (v) {
    return v.to;
  }))),
  searchQueryPerformance: (0, _from2.default)(new _set2.default(_initData2.default.adPerformance.columnTranslation.map(function (v) {
    return v.to;
  })))
};

exports.default = {
  name: "InputLanguage",
  components: {
    SummaryRegex: _SummaryRegex2.default,
    ColumnTranslation: _ColumnTranslation2.default
  },
  data: function data() {
    return {
      state: "ready",
      translationTargets: translationTargets,
      config: null
    };
  },

  reactive: {
    language: function language() {
      return ['config', 'inputLanguage', this.$route.params.name];
    }
  },
  watch: {
    language: function language(v) {
      this.config = v.config;
    }
  },
  computed: {},
  methods: {
    save: function save() {
      var _this = this;

      this.state = "working";
      _api2.default.request(['config', 'saveInputLanguage'], this.language.id, this.config).then(function (done) {
        _this.deleting = null;
        _this.state = "ready";
      });
    }
  }
};

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(10);

var _api2 = _interopRequireDefault(_api);

var _config = __webpack_require__(90);

var _config2 = _interopRequireDefault(_config);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'log',
  data: function data() {
    return {};
  },

  reactive: {
    log: function log() {
      return ['logs', 'log', this.$route.params.logId];
    },
    logMessages: function logMessages() {
      return ['logs', 'logMessages', this.$route.params.logId];
    },
    user: function user() {
      return this.log ? ['userAdmin', 'user', this.log.userId] : null;
    }
  },
  computed: {
    sortedLogMessages: function sortedLogMessages() {
      var messages = this.logMessages;
      if (!messages) return [];
      messages.sort(function (a, b) {
        return a.timestamp - b.timestamp;
      });
      return messages;
    }
  },
  watch: {},
  methods: {
    formatTimestamp: function formatTimestamp(timestamp) {
      return (0, _moment2.default)(timestamp).format("HH:mm:ss");
    }
  },
  created: function created() {},
  beforeDestroy: function beforeDestroy() {},
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
  }
};

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _api = __webpack_require__(10);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'logs',
  data: function data() {
    return {
      state: 'loading',
      search: ''
    };
  },

  reactive: {
    logs: ['logs', 'logs']
  },
  computed: {
    sortedLogs: function sortedLogs() {
      return this.logs.sort;
    }
  },
  watch: {
    logs: function logs() {
      this.state = 'loaded';
    }
  },
  methods: {
    formatTime: function formatTime(t) {
      return (0, _moment2.default)(t).format('MMMM Do YYYY, h:mm:ss a');
    },
    addUser: function addUser() {
      var _this = this;

      this.state = 'working';
      _api2.default.request(['userAdmin', 'createUser'], 'empty').then(function (userId) {
        _this.$router.push({ name: 'user', params: { userId: userId } });
      });
    },
    openAddEmailPasswordDialog: function openAddEmailPasswordDialog() {
      this.newEmail = '';
      this.newPassword = '';
      this.addEmailPasswordDialog = true;
    },
    addEmailPassword: function addEmailPassword() {
      var _this2 = this;

      this.addEmailPasswordDialog = false;
      this.state = 'working';
      _api2.default.request(['userAdmin', 'createEmailUser'], this.newEmail, this.newPassword).then(function (userId) {
        _this2.state = 'loaded';
        _this2.$router.push({ name: 'user', params: { userId: userId } });
      });
    }
  },
  created: function created() {},
  beforeDestroy: function beforeDestroy() {},
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
  }
};

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(59);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(23);

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = __webpack_require__(22);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _api = __webpack_require__(10);

var _api2 = _interopRequireDefault(_api);

var _config = __webpack_require__(90);

var _config2 = _interopRequireDefault(_config);

var _PhoneInput = __webpack_require__(404);

var _PhoneInput2 = _interopRequireDefault(_PhoneInput);

var _CountryInput = __webpack_require__(402);

var _CountryInput2 = _interopRequireDefault(_CountryInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'user',
  components: {
    PhoneInput: _PhoneInput2.default, CountryInput: _CountryInput2.default
  },
  data: function data() {
    return {
      user: null,
      possibleRoles: _config2.default.possibleRoles,
      displayName: '',
      roles: [],
      state: 'loading',
      confirmDialog: null,
      changeEmailPasswordDialog: false,
      newPasswordEmail: '',
      newPassword1: '',
      newPassword2: '',
      addEmailPasswordDialog: false,
      newEmail: '',
      userDataProps: [],
      notMatch: false,
      required: false,
      dialogError: null
    };
  },

  computed: {
    rolesChanged: function rolesChanged() {
      console.log("ROLES CHANGED?", this.roles, this.user.roles);
      if (this.roles.length != this.user.roles.length) return true;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.roles), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var role = _step.value;
          if (this.user.roles.indexOf(role) == -1) return true;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(this.user.roles), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _role = _step2.value;
          if (this.roles.indexOf(_role) == -1) return true;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return false;
    },
    editedUserData: function editedUserData() {
      var obj = {};
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = (0, _getIterator3.default)(this.userDataProps), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var prop = _step3.value;

          if (prop.key.length > 0) obj[prop.key] = prop.value;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return obj;
    },
    userDataChanged: function userDataChanged() {
      return (0, _stringify2.default)(this.user.userData) != (0, _stringify2.default)(this.editedUserData);
    },
    userChanged: function userChanged() {
      return this.rolesChanged || this.userDataChanged;
    }
  },
  watch: {
    '$route': function $route(to, from) {
      if (this.observable) this.observable.unbindProperty(this, "user");
      this.observable = _api2.default.observable(['userAdmin', 'user', to.params.userId]);
      this.observable.bindProperty(this, "user");
    },
    user: function user(v) {
      if (v != null) this.state = 'loaded';
      this.displayName = this.user.display;
      this.userDataProps = [];
      for (var key in this.user.userData) {
        this.userDataProps.push({
          key: key,
          value: this.user.userData[key]
        });
      }
      this.roles = this.user.roles.slice() || [];
    }
  },
  methods: {
    propType: function propType(prop) {
      if (prop.key == 'phoneNumber') return "phone";
      if (prop.key == 'country') return "country";
      return 'text';
    },
    toggleRole: function toggleRole(role) {
      var index = this.roles.indexOf(role);
      if (index != -1) this.roles.splice(index, 1);
      if (index == -1) this.roles.push(role);
    },
    save: function save() {
      var _this = this;

      this.state = 'saving';
      var savePromises = [];
      if (this.rolesChanged) savePromises.push(_api2.default.request(['userAdmin', 'updateRoles'], this.user.id, this.roles));
      if (this.userDataChanged) savePromises.push(_api2.default.request(['userAdmin', 'updateUserData'], this.user.id, this.editedUserData));
      _promise2.default.all(savePromises).then(function (results) {
        _this.state = 'saved';
      }).catch(function (error) {
        return _this.state = 'broken';
      });
    },
    closeDialog: function closeDialog() {
      this.confirmDialog = null;
    },
    openRemoveDialog: function openRemoveDialog() {
      var _this2 = this;

      this.confirmDialog = {
        title: "Remove User?",
        text: "Do you really want to remove user " + this.user.display + "?",
        action: function action() {
          _this2.state = 'saving';
          _api2.default.request(['userAdmin', 'removeUser'], _this2.user.id).then(function (result) {
            _this2.$router.replace({ name: 'users' });
          });
        }
      };
    },
    openChangeEmailPasswordDialog: function openChangeEmailPasswordDialog(loginMethod) {
      this.changeEmailPasswordDialog = true;
      this.newPassword1 = '';
      this.newPassword2 = '';
      this.newPasswordEmail = loginMethod.id;
      this.required = false;
      this.notMatch = false;
    },
    changeEmailPassword: function changeEmailPassword() {
      var _this3 = this;

      if (this.newPassword1.trim() == '' || this.newPassword2.trim() == '') {
        this.required = true;
        if (this.newPassword2.trim() == '') {
          this.$refs.newPassword2.parentElement.setAttribute('class', this.$refs.newPassword2.parentElement.getAttribute('class') + ' is-invalid');
          this.$refs.newPassword2.focus();
        }
        if (this.newPassword1.trim() == '') {
          this.$refs.newPassword1.parentElement.setAttribute('class', this.$refs.newPassword1.parentElement.getAttribute('class') + ' is-invalid');
          this.$refs.newPassword1.focus();
        }
        return;
      }

      this.notMatch = this.newPassword1 != this.newPassword2;
      if (this.notMatch) {
        this.$refs.newPassword2.parentElement.setAttribute('class', this.$refs.newPassword2.parentElement.getAttribute('class') + ' is-invalid');
        this.$refs.newPassword2.focus();
        return;
      }

      this.changeEmailPasswordDialog = false;
      this.state = 'saving';
      _api2.default.request(['userAdmin', 'updateEmailPassword'], this.newPasswordEmail, this.newPassword1).then(function (result) {
        _this3.state = 'loaded';
      }).catch(function (error) {
        _this3.dialogError = error;
        _this3.state = 'loaded';
      });
    },
    openRemoveEmailDialog: function openRemoveEmailDialog(loginMethod) {
      var _this4 = this;

      this.confirmDialog = {
        title: "Remove login method?",
        text: "Do you really want to remove user " + this.user.display + " email " + loginMethod.id + " ?",
        action: function action() {
          _this4.state = 'saving';
          _api2.default.request(['userAdmin', 'removeEmailFromUser'], _this4.user.id, loginMethod.id).then(function (result) {
            _this4.state = 'loaded';
            _this4.closeDialog();
          });
        }
      };
    },
    openAddEmailPasswordDialog: function openAddEmailPasswordDialog() {
      this.addEmailPasswordDialog = true;
      this.newPassword1 = '';
      this.newPassword2 = '';
      this.newEmail = '';
      this.required = false;
      this.notMatch = false;
    },
    addEmailPassword: function addEmailPassword() {
      var _this5 = this;

      if (this.newPassword1.trim() == '' || this.newPassword2.trim() == '') {
        this.required = true;
        if (this.newPassword2.trim() == '') {
          this.$refs.newPassword2.parentElement.setAttribute('class', this.$refs.newPassword2.parentElement.getAttribute('class') + ' is-invalid');
          this.$refs.newPassword2.focus();
        }
        if (this.newPassword1.trim() == '') {
          this.$refs.newPassword1.parentElement.setAttribute('class', this.$refs.newPassword1.parentElement.getAttribute('class') + ' is-invalid');
          this.$refs.newPassword1.focus();
        }
        return;
      }

      this.notMatch = this.newPassword1 != this.newPassword2;
      if (this.notMatch) {
        this.$refs.newPassword2.parentElement.setAttribute('class', this.$refs.newPassword2.parentElement.getAttribute('class') + ' is-invalid');
        this.$refs.newPassword2.focus();
        return;
      }

      this.state = 'saving';
      _api2.default.request(['userAdmin', 'addEmailToUser'], this.user.id, this.newEmail, this.newPassword1).then(function (result) {
        _this5.state = 'loaded';
        _this5.addEmailPasswordDialog = false;
      }).catch(function (error) {
        _this5.dialogError = error;
        _this5.state = 'loaded';
      });
    },
    deleteProp: function deleteProp(index) {
      this.userDataProps.splice(index, 1);
    },
    addProp: function addProp() {
      this.userDataProps.push({
        key: '',
        value: ''
      });
    }
  },
  created: function created() {},
  beforeDestroy: function beforeDestroy() {
    if (this.observable) this.observable.unbindProperty(this, "user");
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
    this.observable = _api2.default.observable(['userAdmin', 'user', this.$route.params.userId]);
    this.observable.bindProperty(this, "user");
  }
};

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(10);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'users',
  data: function data() {
    return {
      state: 'loading',
      addEmailPasswordDialog: false,
      newEmail: '',
      newPassword: '',
      search: ''
    };
  },

  reactive: {
    usersList: ['userAdmin', 'usersList']
  },
  computed: {
    filteredUsersList: function filteredUsersList() {
      var search = this.search.trim();
      if (search.length == 0) return this.usersList;
      return this.usersList.filter(function (user) {
        return (user.display || 'unknown').indexOf(search) != -1;
      });
    }
  },
  watch: {
    usersList: function usersList() {
      this.state = 'loaded';
    }
  },
  methods: {
    addUser: function addUser() {
      var _this = this;

      this.state = 'working';
      _api2.default.request(['userAdmin', 'createUser'], 'empty').then(function (userId) {
        _this.$router.push({ name: 'user', params: { userId: userId } });
      });
    },
    openAddEmailPasswordDialog: function openAddEmailPasswordDialog() {
      this.newEmail = '';
      this.newPassword = '';
      this.addEmailPasswordDialog = true;
    },
    addEmailPassword: function addEmailPassword() {
      var _this2 = this;

      this.addEmailPasswordDialog = false;
      this.state = 'working';
      _api2.default.request(['userAdmin', 'createEmailUser'], this.newEmail, this.newPassword).then(function (userId) {
        _this2.state = 'loaded';
        _this2.$router.push({ name: 'user', params: { userId: userId } });
      });
    }
  },
  created: function created() {},
  beforeDestroy: function beforeDestroy() {},
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
  }
};

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _set = __webpack_require__(60);

var _set2 = _interopRequireDefault(_set);

var _SingleSelect = __webpack_require__(406);

var _SingleSelect2 = _interopRequireDefault(_SingleSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "ColumnTranslation",
  components: {
    SingleSelect: _SingleSelect2.default
  },
  props: {
    value: {
      type: Array
    },
    targets: {
      type: Array
    }
  },
  data: function data() {
    return {
      required: true,
      errors: new Array(this.value.length)
    };
  },

  watch: {
    value: function value(v) {
      this.computeErrors();
    }
  },
  computed: {},
  methods: {
    updateFrom: function updateFrom(index, value) {
      this.value[index].from = value;
      this.computeErrors();
      this.$emit('input', this.value);
    },
    updateTo: function updateTo(index, value) {
      console.log("UPDATE TO", index, value);
      this.value[index].to = value;
      this.computeErrors();
      this.value.errors = this.errors;
      this.$emit('input', this.value);
    },
    computeErrors: function computeErrors() {
      var froms = new _set2.default();
      var errors = new Array(this.value.length);
      for (var i = 0; i < this.value.length; i++) {
        var tr = this.value[i];
        if (froms.has(tr.from)) errors[i] = 'Duplicate Entry - there is another position which translates from ' + tr.from;
        froms.add(tr.from);
      }
      this.errors = errors;
    },
    addTranslation: function addTranslation() {
      this.value.push({
        from: this.targets[0],
        to: this.targets[0]
      });
      this.value.errors = this.errors;
      this.$emit('input', this.value);
    },
    deleteTranslation: function deleteTranslation(index) {
      this.value.splice(index, 1);
      this.value.errors = this.errors;
      this.$emit('input', this.value);
    }
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
    this.computeErrors();
  }
};

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(22);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _api = __webpack_require__(10);

var _api2 = _interopRequireDefault(_api);

var _initData = __webpack_require__(89);

var _initData2 = _interopRequireDefault(_initData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "InputLanguages",
  reactive: {
    languages: ['config', 'inputLanguagesList']
  },
  data: function data() {
    return {
      state: "ready",
      required: false,
      newLanguageCode: "",

      renaming: null,
      deleting: null,
      newName: ""
    };
  },

  methods: {
    addLanguage: function addLanguage() {
      var _this = this;

      if (this.newLanguageCode.trim() == '') {

        this.required = true;
        this.$refs.fileName.parentElement.setAttribute('class', this.$refs.fileName.parentElement.getAttribute('class') + ' is-invalid');
        this.$refs.fileName.focus();

        return;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.languages), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var lang = _step.value;

          if (lang.name == this.newLanguageCode) {
            this.required = true;
            this.$refs.fileName.parentElement.setAttribute('class', this.$refs.fileName.parentElement.getAttribute('class') + ' is-invalid');
            this.$refs.fileName.focus();
            return;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.state = "working";
      _api2.default.request(['config', 'saveInputLanguage'], this.newLanguageCode, _initData2.default).then(function (result) {
        return _this.state = "done";
      }).catch(function (error) {
        _this.error = error;
        _this.state = "error";
      });
    },
    remove: function remove(file) {
      this.deleting = file;
    },
    rename: function rename(file) {
      this.newName = file.name;
      this.renaming = file;
    },
    finishRename: function finishRename() {
      var _this2 = this;

      this.state = "working";
      _api2.default.request(['config', 'renameInputLanguage'], this.renaming.name, this.newName).then(function (done) {
        _this2.renaming.name = _this2.newName;
        _this2.renaming = null;
        _this2.state = "ready";
      });
    },
    confirmDelete: function confirmDelete() {
      var _this3 = this;

      this.state = "working";
      _api2.default.request(['config', 'removeInputLanguage'], this.deleting.name).then(function (done) {
        _this3.deleting = null;
        _this3.state = "ready";
      });
    },
    cancelDelete: function cancelDelete() {
      this.deleting = null;
    }
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
  }
};

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _set = __webpack_require__(60);

var _set2 = _interopRequireDefault(_set);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "SummaryRegex",
  props: {
    value: {
      type: Array
    }
  },
  data: function data() {
    return {
      errors: [],
      required: true
    };
  },

  methods: {
    updateRegex: function updateRegex(index, value) {
      this.value[index] = value;
      this.computeErrors();
      this.value.errors = this.errors;
      this.$emit('input', this.value);
    },
    computeErrors: function computeErrors() {
      var regexs = new _set2.default();
      var errors = new Array(this.value.length);
      for (var i = 0; i < this.value.length; i++) {
        var r = this.value[i];
        if (regexs.has(r)) errors[i] = "Duplicate Entry";
        regexs.add(r);
      }
      this.errors = errors;
    },
    addRegex: function addRegex() {
      this.value.push("^Total");
      this.computeErrors();
      this.value.errors = this.errors;
      this.$emit('input', this.value);
    },
    deleteRegex: function deleteRegex(index) {
      this.value.splice(index, 1);
      this.value.errors = this.errors;
      this.$emit('input', this.value);
    }
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
    this.computeErrors();
  }
};

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(10);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'login-form',
  metaInfo: {
    title: 'Sign In'
  },
  data: function data() {
    return {
      state: "ready",
      error: null,
      email: "",
      password: "",
      required: false
    };
  },

  methods: {
    login: function login(e) {
      var _this = this;

      e.preventDefault();

      if (this.email.trim() == '' || this.password.trim() == '') {
        this.required = true;
        if (this.email.trim() == '') {
          this.$refs.email.parentElement.setAttribute('class', this.$refs.email.parentElement.getAttribute('class') + ' is-invalid');
          this.$refs.email.focus();
        }
        if (this.password.trim() == '') {
          this.$refs.password.parentElement.setAttribute('class', this.$refs.password.parentElement.getAttribute('class') + ' is-invalid');
          this.$refs.password.focus();
        }
        return;
      }

      this.state = "working";
      _api2.default.request(["emailPassword", "login"], this.email, this.password).then(function (result) {
        _this.state = "done";
      }).catch(function (error) {
        _this.error = error;
        _this.state = "ready";
      });
    }
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
  }
};

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(10);

var _api2 = _interopRequireDefault(_api);

var _countries = __webpack_require__(44);

var _countries2 = _interopRequireDefault(_countries);

var _overlayModel = __webpack_require__(33);

var _overlayModel2 = _interopRequireDefault(_overlayModel);

var _CountryPicker = __webpack_require__(403);

var _CountryPicker2 = _interopRequireDefault(_CountryPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(115);

exports.default = {
  name: 'country-input',
  props: {
    value: {},
    required: {
      type: Boolean,
      required: true
    },
    label: {
      type: String
    },
    invalid: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      liveValue: this.value
    };
  },

  computed: {
    empty: function empty() {
      if (!this.liveValue) return true;
      if (this.liveValue.trim().length == 0) return true;
      return false;
    },
    name: function name() {
      var _this = this;

      if (this.empty) return "";
      var country = _countries2.default.filter(function (c) {
        return c.code == _this.liveValue;
      })[0];
      if (!country) return "Unknown";
      return country.name;
    }
  },
  watch: {
    geoIpIsoCode: function geoIpIsoCode(iso) {
      if (!this.isoCode) {
        this.isoCode = iso;
        this.prefix = _countries2.default.filter(function (country) {
          return country.code == iso;
        })[0].dial_code;
      }
    },
    liveValue: function liveValue(value) {
      this.$emit('update:value', value);
    },
    invalid: function invalid(v) {
      if (!v) return;
      if (!this.number.match(/^[0-9 #+-]{3,}$/)) {
        this.$refs.number.parentElement.setAttribute('class', this.$refs.number.parentElement.getAttribute('class') + ' is-invalid');
      }
    }
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  created: function created() {},
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
  },

  methods: {
    showPrefixMenu: function showPrefixMenu() {
      var _this2 = this;

      _overlayModel2.default.show({
        component: _CountryPicker2.default,
        props: {
          anchor: _overlayModel2.default.elementAnchor(this.$refs.country)
        },
        on: {
          selected: function selected(code) {
            console.log("SELECTED COUNTRY", code);
            _this2.liveValue = code;
          }
        }
      });
    }
  }
};

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(27);

var _vue2 = _interopRequireDefault(_vue);

var _overlayLayer = __webpack_require__(32);

var _countries2 = __webpack_require__(44);

var _countries3 = _interopRequireDefault(_countries2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CountryPicker',
  props: ['anchor'],
  components: { OverlayAnchor: _overlayLayer.OverlayAnchor },
  data: function data() {
    return {
      directions: [{ x: 1, y: 1, ax: -1, ay: 1 }, { x: 1, y: -1, ax: -1, ay: -1 }],
      position: { x: 0, y: 0 },
      search: ""
    };
  },

  computed: {
    windowDimmensions: function windowDimmensions() {
      return _overlayLayer.windowDimmensions;
    },
    countries: function countries() {
      return _countries3.default;
    },
    filteredCountries: function filteredCountries() {
      var query = this.search.toLowerCase().trim();
      if (query.length == 0) return this.countries;
      return this.countries.filter(function (country) {
        if (country.name.toLowerCase().indexOf(query) != -1) return true;
        if (country.code.toLowerCase().indexOf(query) != -1) return true;
        if (country.dial_code.indexOf(query) != -1) return true;
        return false;
      });
    }
  },
  methods: {
    updatePosition: function updatePosition(position) {
      this.position = position;
    },
    focusSearch: function focusSearch() {
      var _this = this;

      if (this.$refs.search) {
        this.$refs.search.focus();
        this.$refs.search.select();
      }
      if (document.activeElement != this.$refs.search) {
        setTimeout(function () {
          return _this.focusSearch();
        }, 50);
      }
    },
    countrySelected: function countrySelected(country) {
      this.$emit("selected", country.code);
      this.$emit("close");
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    componentHandler.upgradeAllRegistered();
    setTimeout(function () {
      return _this2.focusSearch();
    }, 50);
  }
};

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(10);

var _api2 = _interopRequireDefault(_api);

var _countries = __webpack_require__(44);

var _countries2 = _interopRequireDefault(_countries);

var _overlayModel = __webpack_require__(33);

var _overlayModel2 = _interopRequireDefault(_overlayModel);

var _PhonePrefixPicker = __webpack_require__(405);

var _PhonePrefixPicker2 = _interopRequireDefault(_PhonePrefixPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(115);

exports.default = {
  name: 'phone-input',
  props: {
    value: {},
    required: {
      type: Boolean,
      required: true
    },
    label: {
      type: String
    },
    invalid: {
      type: Boolean
    }
  },
  data: function data() {
    var sep = this.value.indexOf(' ');
    var empty = sep == -1;
    var prefix = empty ? "" : this.value.slice(0, sep);
    var number = empty ? "" : this.value.slice(sep + 1);
    var country = _countries2.default.filter(function (c) {
      return c.dial_code == prefix;
    })[0];
    return {
      prefix: prefix, number: number,
      isoCode: country ? country.isoCode : null
    };
  },

  computed: {
    liveValue: function liveValue() {
      return (this.prefix + " " + this.number).trim();
    },
    prefixInvalid: function prefixInvalid() {
      return this.invalid && this.prefix.trim().length == 0;
    }
  },
  watch: {
    liveValue: function liveValue(value) {
      this.$emit('update:value', value);
    },
    invalid: function invalid(v) {
      if (!v) return;
      if (!this.number.match(/^[0-9 #+-]{3,}$/)) {
        this.$refs.number.parentElement.setAttribute('class', this.$refs.number.parentElement.getAttribute('class') + ' is-invalid');
      }
    }
  },
  updated: function updated() {
    componentHandler.upgradeAllRegistered();
  },
  created: function created() {},
  mounted: function mounted() {
    componentHandler.upgradeAllRegistered();
  },

  methods: {
    showPrefixMenu: function showPrefixMenu() {
      var _this = this;

      _overlayModel2.default.show({
        component: _PhonePrefixPicker2.default,
        props: {
          anchor: _overlayModel2.default.elementAnchor(this.$refs.prefix)
        },
        on: {
          selected: function selected(code) {
            return _this.prefix = code;
          }
        }
      });
    }
  }
};

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(27);

var _vue2 = _interopRequireDefault(_vue);

var _overlayLayer = __webpack_require__(32);

var _countries2 = __webpack_require__(44);

var _countries3 = _interopRequireDefault(_countries2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'PhonePrefixPicker',
  props: ['anchor'],
  components: { OverlayAnchor: _overlayLayer.OverlayAnchor },
  data: function data() {
    return {
      directions: [{ x: 1, y: 1, ax: -1, ay: 1 }, { x: 1, y: -1, ax: -1, ay: -1 }],
      position: { x: 0, y: 0 },
      search: ""
    };
  },

  computed: {
    windowDimmensions: function windowDimmensions() {
      return _overlayLayer.windowDimmensions;
    },
    countries: function countries() {
      return _countries3.default;
    },
    filteredCountries: function filteredCountries() {
      var query = this.search.toLowerCase().trim();
      if (query.length == 0) return this.countries;
      return this.countries.filter(function (country) {
        if (country.name.toLowerCase().indexOf(query) != -1) return true;
        if (country.code.toLowerCase().indexOf(query) != -1) return true;
        if (country.dial_code.indexOf(query) != -1) return true;
        return false;
      });
    }
  },
  methods: {
    updatePosition: function updatePosition(position) {
      this.position = position;
    },
    focusSearch: function focusSearch() {
      var _this = this;

      if (this.$refs.search) {
        this.$refs.search.focus();
        this.$refs.search.select();
      }
      if (document.activeElement != this.$refs.search) {
        setTimeout(function () {
          return _this.focusSearch();
        }, 50);
      }
    },
    countrySelected: function countrySelected(country) {
      this.$emit("selected", country.dial_code);
      this.$emit("close");
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    componentHandler.upgradeAllRegistered();
    setTimeout(function () {
      return _this2.focusSearch();
    }, 50);
  }
};

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _overlayModel = __webpack_require__(33);

var _overlayModel2 = _interopRequireDefault(_overlayModel);

var _SingleSelectPicker = __webpack_require__(407);

var _SingleSelectPicker2 = _interopRequireDefault(_SingleSelectPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uniqCounter = 0;
var focusLostListener = null;

exports.default = {
  name: 'single-select',
  props: {
    options: {
      type: Array
    },
    value: {},
    display: {
      type: Function,
      default: function _default(x) {
        return x.title || x;
      }
    }
  },
  data: function data() {
    return {
      uniq: "" + uniqCounter++,
      overlayStackId: null,
      lastCloseTime: 0,
      liveValue: this.value
    };
  },

  computed: {
    visibleValue: function visibleValue() {
      return this.display(this.value);
    },
    visibleOptions: function visibleOptions() {
      var options = this.options.slice();
      return options;
    }
  },
  watch: {
    value: function value(q) {
      this.liveValue = q;
    }
  },
  methods: {
    set: function set(option) {
      this.liveValue = option;
      this.$emit("input", this.liveValue);
      if (this.overlayStackId !== null) {
        _overlayModel2.default.close(this.overlayStackId);
      }
    },
    toggleMenu: function toggleMenu() {
      var _this = this;

      if (this.overlayStackId === null && Date.now() - this.lastCloseTime > 230) {
        this.overlayStackId = _overlayModel2.default.show({
          component: _SingleSelectPicker2.default,
          props: {
            anchor: _overlayModel2.default.elementAnchor(this.$refs.button),
            value: this.value,
            options: this.options,
            allOption: this.allOption,
            without: this.without,
            many: this.many,
            display: this.display
          },
          on: {
            'input': function input(value) {
              return _this.set(value);
            },
            close: function close() {
              _this.overlayStackId = null;
              _this.lastCloseTime = Date.now();
            }
          }
        });
      } else {
        _overlayModel2.default.close(this.overlayStackId);
        this.overlayStackId = null;
        this.lastCloseTime = Date.now();
      }
    }
  }
};

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _overlayLayer = __webpack_require__(32);

var _overlayModel = __webpack_require__(33);

var _overlayModel2 = _interopRequireDefault(_overlayModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uniqCounter = 0;
var focusLostListener = null;

exports.default = {
  name: 'single-select-picker',
  components: { OverlayAnchor: _overlayLayer.OverlayAnchor },
  props: {
    options: {
      type: Array
    },
    value: {},
    anchor: {},
    display: {
      type: Function,
      default: function _default(x) {
        return x.title || x;
      }
    }
  },
  data: function data() {
    return {
      directions: [{ x: 1, y: 1, ax: -1, ay: 1 }, { x: 1, y: -1, ax: -1, ay: -1 }],
      uniq: "" + uniqCounter++,
      liveValue: this.value,
      position: { x: 0, y: 0 }
    };
  },

  computed: {
    windowDimmensions: function windowDimmensions() {
      return _overlayLayer.windowDimmensions;
    },
    visibleOptions: function visibleOptions() {
      var options = this.options.slice();
      return options;
    }
  },
  watch: {
    value: function value(q) {
      this.liveValue = q;
    }
  },
  methods: {
    set: function set(option) {
      this.liveValue = option;
      this.$emit("input", this.liveValue);
    },
    updatePosition: function updatePosition(position) {
      this.position.x = position.x;
      this.position.y = position.y;
    }
  }
};

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(27);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(253);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(251);

var _router2 = _interopRequireDefault(_router);

var _vueAsyncComputed = __webpack_require__(252);

var _vueAsyncComputed2 = _interopRequireDefault(_vueAsyncComputed);

var _api = __webpack_require__(10);

var _api2 = _interopRequireDefault(_api);

var _reactiveDaoVue = __webpack_require__(250);

var _reactiveDaoVue2 = _interopRequireDefault(_reactiveDaoVue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueAsyncComputed2.default);

_vue2.default.use(_reactiveDaoVue2.default, {
  dao: _api2.default
});

_vue2.default.config.productionTip = false;

new _vue2.default({
  el: '#app',
  router: _router2.default,
  render: function render(h) {
    return h(_App2.default);
  }
});

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.windowDimmensions = exports.OverlayAnchor = exports.createOverlayModel = exports.OverlayComponent = undefined;

var _extends2 = __webpack_require__(285);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(27);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createElement = void 0;

var getElementPosition = function getElementPosition(element) {
  var o = element;
  var x = 0;
  var y = 0;
  while (true) {
    x += o.offsetLeft;
    y += o.offsetTop;
    o = o.offsetParent;
    if (!o) return {
      x: x,
      y: y
    };
    if (o.scrollLeft) x -= o.scrollLeft;
    if (o.scrollTop) y -= o.scrollTop;
  }
};

function createOverlayModel() {
  return new _vue2.default({
    data: {
      overlayStack: [],
      createElement: null
    },
    methods: {
      show: function show(_ref) {
        var _this = this;

        var anchor = _ref.anchor,
            direction = _ref.direction,
            component = _ref.component,
            props = _ref.props,
            on = _ref.on,
            slots = _ref.slots,
            parentId = _ref.parentId;

        parentId = parentId || 0;
        props = props || {};
        on = on || {};
        slots = slots || [];
        this.overlayStack.splice(parentId, Infinity);
        var stackId = this.overlayStack.length + 1;
        props = {
          props: (0, _extends3.default)({}, props, {
            stackId: stackId
          }),
          attrs: {
            'data-overlay-stack': stackId
          },
          on: (0, _extends3.default)({}, on, {
            close: function close() {
              return _this.close(stackId);
            },
            closeAll: function closeAll() {
              return _this.closeAll();
            },
            overlay: function overlay(definition) {
              return _this.show((0, _extends3.default)({}, definition, { parentId: stackId }));
            }
          })
        };
        this.overlayStack.push(this.createElement(component, props, slots));
      },
      close: function close(stackId) {
        this.overlayStack.splice(stackId - 1, Infinity);
      },
      closeAll: function closeAll() {
        this.overlayStack.splice(0, Infinity);
      },
      elementAnchor: function elementAnchor(element) {
        var position = getElementPosition(element);
        return (0, _extends3.default)({}, position, { w: element.clientWidth, h: element.clientHeight });
      }
    }
  });
}

var OverlayComponent = {
  name: 'OverlayLayer',
  props: {
    overlayModel: {
      required: true,
      type: Object
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.focusLostListener = function (ev) {
      var stackId = void 0;
      var tg = ev.target;
      while (tg) {
        stackId = +tg.getAttribute('data-overlay-stack');
        if (stackId) break;
        tg = tg.parentElement;
      }
      if (stackId) {
        _this2.overlayModel.close(stackId + 1);
      } else {
        _this2.overlayModel.closeAll();
      }
    };
    document.body.addEventListener("touch", this.focusLostListener, true);
    document.body.addEventListener("click", this.focusLostListener, true);
  },
  beforeDestroy: function beforeDestroy() {
    document.body.removeEventListener("touch", this.focusLostListener);
    document.body.removeEventListener("click", this.focusLostListener);
  },
  render: function render(createElement) {
    this.overlayModel.createElement = createElement;
    return createElement("div", { class: "overlayLayer" }, this.overlayModel.overlayStack);
  }
};

var allDirections = [{ x: 1, y: 1 }, { x: 1, y: 0 }, { x: 1, y: -1 }, { x: 0, y: 1 }, { x: 0, y: -1 }, { x: -1, y: 1 }, { x: -1, y: 0 }, { x: -1, y: -1 }];

var windowDimmensions = new _vue2.default({
  data: {
    width: window.innerWidth,
    height: window.innerHeight
  }
});
window.addEventListener('resize', function () {
  windowDimmensions.width = window.innerWidth;
  windowDimmensions.height = window.innerHeight;
});

function computeDimmensions(anchor, size, direction) {
  var aw = anchor.w || 0;
  var ah = anchor.h || 0;
  var ax = anchor.x || 0;
  var ay = anchor.y || 0;

  var dx = direction.x || 0;
  var dy = direction.y || 0;
  var dax = direction.ax || 0;
  var day = direction.ay || 0;

  var acx = ax + aw / 2;
  var acy = ay + ah / 2;
  var hx = acx + aw / 2 * dax;
  var hy = acy + ah / 2 * day;

  var mw = size.x || 0;
  var mh = size.y || 0;
  var mcx = -mw / 2;
  var mcy = -mh / 2;

  var xp = hx + mcx + mw / 2 * dx;
  var yp = hy + mcy + mh / 2 * dy;

  return {
    x: xp,
    y: yp,
    x2: xp + mw,
    y2: yp + mh
  };
}

var OverlayAnchor = {
  name: 'OverlayAnchor',
  props: {
    anchor: {
      required: true,
      type: Object
    },
    directions: {
      default: function _default() {
        return allDirections;
      },
      type: Array
    }
  },
  data: function data() {
    return {
      width: 0,
      height: 0
    };
  },

  computed: {
    possibleDirections: function possibleDirections() {
      var _this3 = this;

      var size = { x: this.width, y: this.height };
      return this.directions.map(function (direction) {
        return {
          direction: direction,
          position: computeDimmensions(_this3.anchor, size, direction)
        };
      }).filter(function (dir) {
        if (dir.position.x < 0) return false;
        if (dir.position.x2 > windowDimmensions.width) return false;
        if (dir.position.y < 0) return false;
        if (dir.position.y2 > windowDimmensions.height) return false;
        return true;
      });
    },
    style: function style() {
      var directions = this.possibleDirections;
      if (directions.length == 0) return { display: "none" };
      this.$emit("positioned", directions[0].position);
      return {
        left: directions[0].position.x + 'px',
        top: directions[0].position.y + 'px'
      };
    }
  },
  methods: {
    updateSize: function updateSize() {
      var _this4 = this;

      if (this.finished) return;
      var element = this.$refs.anchor;
      if (!element) return;
      var width = element.clientWidth;
      var height = element.clientHeight;
      if (width != this.width) this.width = width;
      if (height != this.height) this.height = height;
      setTimeout(function () {
        return _this4.updateSize();
      }, 100);
    }
  },
  mounted: function mounted() {
    this.updateSize();
  },
  beforeDestroy: function beforeDestroy() {
    this.finished = true;
  },
  render: function render(createElement) {
    return createElement("div", {
      'class': 'overlayAnchor',
      style: this.style,
      ref: 'anchor'
    }, this.$slots.default);
  }
};

exports.OverlayComponent = OverlayComponent;
exports.createOverlayModel = createOverlayModel;
exports.OverlayAnchor = OverlayAnchor;
exports.windowDimmensions = windowDimmensions;

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _overlayLayer = __webpack_require__(32);

var overlayModel = (0, _overlayLayer.createOverlayModel)();

exports.default = overlayModel;

/***/ }),

/***/ 344:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 345:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 346:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 347:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 348:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 349:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 350:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 351:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 352:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 353:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 354:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 355:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 356:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 357:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 358:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 359:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 360:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 116,
	"./af.js": 116,
	"./ar": 123,
	"./ar-dz": 117,
	"./ar-dz.js": 117,
	"./ar-kw": 118,
	"./ar-kw.js": 118,
	"./ar-ly": 119,
	"./ar-ly.js": 119,
	"./ar-ma": 120,
	"./ar-ma.js": 120,
	"./ar-sa": 121,
	"./ar-sa.js": 121,
	"./ar-tn": 122,
	"./ar-tn.js": 122,
	"./ar.js": 123,
	"./az": 124,
	"./az.js": 124,
	"./be": 125,
	"./be.js": 125,
	"./bg": 126,
	"./bg.js": 126,
	"./bm": 127,
	"./bm.js": 127,
	"./bn": 128,
	"./bn.js": 128,
	"./bo": 129,
	"./bo.js": 129,
	"./br": 130,
	"./br.js": 130,
	"./bs": 131,
	"./bs.js": 131,
	"./ca": 132,
	"./ca.js": 132,
	"./cs": 133,
	"./cs.js": 133,
	"./cv": 134,
	"./cv.js": 134,
	"./cy": 135,
	"./cy.js": 135,
	"./da": 136,
	"./da.js": 136,
	"./de": 139,
	"./de-at": 137,
	"./de-at.js": 137,
	"./de-ch": 138,
	"./de-ch.js": 138,
	"./de.js": 139,
	"./dv": 140,
	"./dv.js": 140,
	"./el": 141,
	"./el.js": 141,
	"./en-au": 142,
	"./en-au.js": 142,
	"./en-ca": 143,
	"./en-ca.js": 143,
	"./en-gb": 144,
	"./en-gb.js": 144,
	"./en-ie": 145,
	"./en-ie.js": 145,
	"./en-nz": 146,
	"./en-nz.js": 146,
	"./eo": 147,
	"./eo.js": 147,
	"./es": 150,
	"./es-do": 148,
	"./es-do.js": 148,
	"./es-us": 149,
	"./es-us.js": 149,
	"./es.js": 150,
	"./et": 151,
	"./et.js": 151,
	"./eu": 152,
	"./eu.js": 152,
	"./fa": 153,
	"./fa.js": 153,
	"./fi": 154,
	"./fi.js": 154,
	"./fo": 155,
	"./fo.js": 155,
	"./fr": 158,
	"./fr-ca": 156,
	"./fr-ca.js": 156,
	"./fr-ch": 157,
	"./fr-ch.js": 157,
	"./fr.js": 158,
	"./fy": 159,
	"./fy.js": 159,
	"./gd": 160,
	"./gd.js": 160,
	"./gl": 161,
	"./gl.js": 161,
	"./gom-latn": 162,
	"./gom-latn.js": 162,
	"./gu": 163,
	"./gu.js": 163,
	"./he": 164,
	"./he.js": 164,
	"./hi": 165,
	"./hi.js": 165,
	"./hr": 166,
	"./hr.js": 166,
	"./hu": 167,
	"./hu.js": 167,
	"./hy-am": 168,
	"./hy-am.js": 168,
	"./id": 169,
	"./id.js": 169,
	"./is": 170,
	"./is.js": 170,
	"./it": 171,
	"./it.js": 171,
	"./ja": 172,
	"./ja.js": 172,
	"./jv": 173,
	"./jv.js": 173,
	"./ka": 174,
	"./ka.js": 174,
	"./kk": 175,
	"./kk.js": 175,
	"./km": 176,
	"./km.js": 176,
	"./kn": 177,
	"./kn.js": 177,
	"./ko": 178,
	"./ko.js": 178,
	"./ky": 179,
	"./ky.js": 179,
	"./lb": 180,
	"./lb.js": 180,
	"./lo": 181,
	"./lo.js": 181,
	"./lt": 182,
	"./lt.js": 182,
	"./lv": 183,
	"./lv.js": 183,
	"./me": 184,
	"./me.js": 184,
	"./mi": 185,
	"./mi.js": 185,
	"./mk": 186,
	"./mk.js": 186,
	"./ml": 187,
	"./ml.js": 187,
	"./mr": 188,
	"./mr.js": 188,
	"./ms": 190,
	"./ms-my": 189,
	"./ms-my.js": 189,
	"./ms.js": 190,
	"./my": 191,
	"./my.js": 191,
	"./nb": 192,
	"./nb.js": 192,
	"./ne": 193,
	"./ne.js": 193,
	"./nl": 195,
	"./nl-be": 194,
	"./nl-be.js": 194,
	"./nl.js": 195,
	"./nn": 196,
	"./nn.js": 196,
	"./pa-in": 197,
	"./pa-in.js": 197,
	"./pl": 198,
	"./pl.js": 198,
	"./pt": 200,
	"./pt-br": 199,
	"./pt-br.js": 199,
	"./pt.js": 200,
	"./ro": 201,
	"./ro.js": 201,
	"./ru": 202,
	"./ru.js": 202,
	"./sd": 203,
	"./sd.js": 203,
	"./se": 204,
	"./se.js": 204,
	"./si": 205,
	"./si.js": 205,
	"./sk": 206,
	"./sk.js": 206,
	"./sl": 207,
	"./sl.js": 207,
	"./sq": 208,
	"./sq.js": 208,
	"./sr": 210,
	"./sr-cyrl": 209,
	"./sr-cyrl.js": 209,
	"./sr.js": 210,
	"./ss": 211,
	"./ss.js": 211,
	"./sv": 212,
	"./sv.js": 212,
	"./sw": 213,
	"./sw.js": 213,
	"./ta": 214,
	"./ta.js": 214,
	"./te": 215,
	"./te.js": 215,
	"./tet": 216,
	"./tet.js": 216,
	"./th": 217,
	"./th.js": 217,
	"./tl-ph": 218,
	"./tl-ph.js": 218,
	"./tlh": 219,
	"./tlh.js": 219,
	"./tr": 220,
	"./tr.js": 220,
	"./tzl": 221,
	"./tzl.js": 221,
	"./tzm": 223,
	"./tzm-latn": 222,
	"./tzm-latn.js": 222,
	"./tzm.js": 223,
	"./uk": 224,
	"./uk.js": 224,
	"./ur": 225,
	"./ur.js": 225,
	"./uz": 227,
	"./uz-latn": 226,
	"./uz-latn.js": 226,
	"./uz.js": 227,
	"./vi": 228,
	"./vi.js": 228,
	"./x-pseudo": 229,
	"./x-pseudo.js": 229,
	"./yo": 230,
	"./yo.js": 230,
	"./zh-cn": 231,
	"./zh-cn.js": 231,
	"./zh-hk": 232,
	"./zh-hk.js": 232,
	"./zh-tw": 233,
	"./zh-tw.js": 233
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 361;

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(359)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(423),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d78e443a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(351)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(415),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2fb48e82",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(345)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(409),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-04686d84",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(360)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(424),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e75e37c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(344)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(408),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-035c9c3b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(357)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(421),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6be28c48",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(346)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(410),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0b1212c4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(353)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(417),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-430a7544",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(358)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(422),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ad9d8924",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(355)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(419),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4a2c83d5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(348)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(412),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-28b26d3c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(352)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(416),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3714dfb4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(350)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(414),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f0c3c0a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(354)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(418),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-438650b0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(349)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(413),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2a0772f2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(356)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(420),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5d5c3520",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 408:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user"
  }, [_vm._m(0), _vm._v(" "), (!_vm.user) ? _c('div', {
    staticClass: "loading-holder"
  }, [_c('h3', [_vm._v("Loading Data...")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-progress mdl-js-progress mdl-progress__indeterminate"
  }), _vm._v(" "), _c('h4', [_vm._v("Please wait!")])]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "user-card mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.user.display))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-grid",
    class: {
      blurred: _vm.state == 'saving'
    }
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--9-col mdl-cell--12-col-phone"
  }, [_c('p', [_vm._v("User Id: " + _vm._s(_vm.user.id))]), _vm._v(" "), _c('p', [_vm._v("Display name: \"" + _vm._s(_vm.user.display) + "\"")]), _vm._v(" "), _c('div', {
    staticClass: "props"
  }, [_vm._l((_vm.userDataProps), function(prop, index) {
    return _c('div', {
      staticClass: "prop"
    }, [_c('div', {
      staticClass: "field mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (prop.key),
        expression: "prop.key"
      }],
      ref: 'userData_key_' + prop.key,
      refInFor: true,
      staticClass: "mdl-textfield__input",
      attrs: {
        "type": "text",
        "id": 'userData_key_' + prop.key,
        "required": _vm.required
      },
      domProps: {
        "value": (prop.key)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(prop, "key", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "mdl-textfield__label",
      attrs: {
        "for": 'userData_key_' + prop.key
      }
    }, [_vm._v("Field")])]), _vm._v(" "), (_vm.propType(prop) == 'text') ? _c('div', {
      staticClass: "field mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (prop.value),
        expression: "prop.value"
      }],
      ref: 'userData_value_' + prop.key,
      refInFor: true,
      staticClass: "mdl-textfield__input",
      attrs: {
        "type": "text",
        "id": 'userData_value_' + prop.key,
        "required": _vm.required
      },
      domProps: {
        "value": (prop.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(prop, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "mdl-textfield__label",
      attrs: {
        "for": 'userData_value_' + prop.key
      }
    }, [_vm._v(_vm._s(prop.key))])]) : _vm._e(), _vm._v(" "), (_vm.propType(prop) == 'phone') ? _c('PhoneInput', {
      staticClass: "phoneNumber field",
      attrs: {
        "value": prop.value,
        "required": _vm.required,
        "invalid": false,
        "label": prop.key
      },
      on: {
        "update:value": function($event) {
          _vm.$set(prop, "value", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.propType(prop) == 'country') ? _c('CountryInput', {
      staticClass: "country field",
      attrs: {
        "value": prop.value,
        "required": _vm.required,
        "invalid": false,
        "label": prop.key
      },
      on: {
        "update:value": function($event) {
          _vm.$set(prop, "value", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
      on: {
        "click": function($event) {
          _vm.deleteProp(index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete_forever")])]), _vm._v(" "), _c('br')], 1)
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": _vm.addProp
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--3-col mdl-cell--12-col-phone"
  }, [_c('h6', [_vm._v("Roles:")]), _vm._v(" "), _vm._l((_vm.possibleRoles), function(role) {
    return _c('div', {
      staticClass: "role-switch",
      on: {
        "click": function($event) {
          _vm.toggleRole(role)
        }
      }
    }, [_c('span', [(_vm.roles.indexOf(role) != -1) ? _c('i', {
      staticClass: "material-icons"
    }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (_vm.roles.indexOf(role) == -1) ? _c('i', {
      staticClass: "material-icons"
    }, [_vm._v("check_box_outline_blank")]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(role))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border right-actions",
    class: {
      blurred: _vm.state == 'saving'
    }
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "disabled": !_vm.userChanged
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.openRemoveDialog
    }
  }, [_vm._v("\n        Remove\n      ")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand mdl-grid",
    class: {
      blurred: _vm.state == 'saving'
    }
  }, [_vm._l((_vm.user.loginMethods), function(loginMethod) {
    return _c('div', {
      staticClass: "mdl-cell-6-col"
    }, [_c('div', {
      staticClass: "login-method mdl-card mdl-shadow--2dp"
    }, [_c('div', {
      staticClass: "mdl-card__title mdl-color--primary"
    }, [_vm._v("\n            " + _vm._s(loginMethod.type) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__supporting-text"
    }, [_c('p', [_vm._v(_vm._s(loginMethod.id))])]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__actions mdl-card--border"
    }, [(loginMethod.type == 'emailPassword') ? _c('a', {
      staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
      on: {
        "click": function($event) {
          _vm.openRemoveEmailDialog(loginMethod)
        }
      }
    }, [_vm._v("\n              Remove\n            ")]) : _vm._e(), _vm._v(" "), (loginMethod.type == 'emailPassword') ? _c('a', {
      staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
      on: {
        "click": function($event) {
          _vm.openChangeEmailPasswordDialog(loginMethod)
        }
      }
    }, [_vm._v("\n              Change password\n            ")]) : _vm._e()])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell-6-col"
  }, [_c('div', {
    staticClass: "add-login-method",
    on: {
      "click": _vm.openAddEmailPasswordDialog
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Add Email/password")])])])], 2)]) : _vm._e(), _vm._v(" "), (_vm.confirmDialog) ? _c('div', {
    staticClass: "dialog-holder"
  }, [_c('div', {
    staticClass: "dialog mdl-card mdl-shadow--4dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--accent"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.confirmDialog.title))]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": _vm.closeDialog
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_vm._v("\n        " + _vm._s(_vm.confirmDialog.text) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border",
    class: {
      blurred: _vm.state == 'saving'
    }
  }, [_c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.confirmDialog.action
    }
  }, [_vm._v("\n          " + _vm._s(_vm.confirmDialog.actionName || 'Ok') + "\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.changeEmailPasswordDialog) ? _c('div', {
    staticClass: "dialog-holder",
    class: {
      blurred: this.state == 'saving'
    }
  }, [_c('div', {
    staticClass: "dialog mdl-card mdl-shadow--4dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--accent"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Change password")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": function () { return _vm.changeEmailPasswordDialog = false; }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [(_vm.error) ? _c('div', {
    staticClass: "serverError"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword1),
      expression: "newPassword1"
    }],
    ref: "newPassword1",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "newPassword1"
    },
    domProps: {
      "value": (_vm.newPassword1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "newPassword2"
    }
  }, [_vm._v("New password")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword2),
      expression: "newPassword2"
    }],
    ref: "newPassword2",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "newPassword2"
    },
    domProps: {
      "value": (_vm.newPassword2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "newPassword2"
    }
  }, [_vm._v("Retype password")]), _vm._v(" "), (_vm.notMatch) ? _c('span', {
    staticClass: "mdl-textfield__error"
  }, [_vm._v("Passwords does not match")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border right-actions",
    class: {
      blurred: _vm.state == 'saving'
    }
  }, [_c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": function () { return _vm.changeEmailPasswordDialog = false; }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.changeEmailPassword
    }
  }, [_vm._v("\n          Change password\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.addEmailPasswordDialog) ? _c('div', {
    staticClass: "dialog-holder",
    class: {
      blurred: this.state == 'saving'
    }
  }, [_c('div', {
    staticClass: "dialog mdl-card mdl-shadow--4dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--accent"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Change password")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": function () { return _vm.addEmailPasswordDialog = false; }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [(_vm.error) ? _c('div', {
    staticClass: "serverError"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield&#45;&#45;floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmail),
      expression: "newEmail"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "email",
      "id": "email"
    },
    domProps: {
      "value": (_vm.newEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("New email")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword1),
      expression: "newPassword1"
    }],
    ref: "newPassword1",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "newPassword1"
    },
    domProps: {
      "value": (_vm.newPassword1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "newPassword2"
    }
  }, [_vm._v("New password")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword2),
      expression: "newPassword2"
    }],
    ref: "newPassword2",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "newPassword2"
    },
    domProps: {
      "value": (_vm.newPassword2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "newPassword2"
    }
  }, [_vm._v("Retype password")]), _vm._v(" "), (_vm.notMatch) ? _c('span', {
    staticClass: "mdl-textfield__error"
  }, [_vm._v("Passwords does not match")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border",
    class: {
      blurred: _vm.state == 'saving'
    }
  }, [_c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": function () { return _vm.addEmailPasswordDialog = false; }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.addEmailPassword
    }
  }, [_vm._v("\n          Add email/password\n        ")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', {
    staticClass: "mdl-layout-title"
  }, [_vm._v("User")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Authentication methods:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--colored"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])])
}]}

/***/ }),

/***/ 409:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "log"
  }, [_vm._m(0), _vm._v(" "), (!_vm.log) ? _c('div', {
    staticClass: "loading-holder"
  }, [_c('h3', [_vm._v("Loading Data...")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-progress mdl-js-progress mdl-progress__indeterminate"
  }), _vm._v(" "), _c('h4', [_vm._v("Please wait!")])]) : _vm._e(), _vm._v(" "), (_vm.log) ? _c('div', {
    staticClass: "log-card mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__supporting-text log-info-bar"
  }, [_c('span', {
    staticClass: "log-info"
  }, [_c('span', {
    staticClass: "log-info-key"
  }, [_vm._v("Date:")]), _vm._v(" "), _c('span', {
    staticClass: "log-info-value"
  }, [_vm._v(_vm._s(_vm.log.date))])]), _vm._v(" "), _c('span', {
    staticClass: "log-info"
  }, [_c('span', {
    staticClass: "log-info-key"
  }, [_vm._v("IP:")]), _vm._v(" "), _c('span', {
    staticClass: "log-info-value"
  }, [_vm._v(_vm._s(_vm.log.ip))])]), _vm._v(" "), (_vm.user) ? _c('span', {
    staticClass: "log-info"
  }, [_c('span', {
    staticClass: "log-info-key"
  }, [_vm._v("User:")]), _vm._v(" "), _c('span', {
    staticClass: "log-info-value"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'user',
        params: {
          userId: _vm.user.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "material-icons user-icon"
  }, [_vm._v("person")]), _vm._v(" "), _c('span', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.user.display))])])], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand log-area"
  }, _vm._l((_vm.sortedLogMessages), function(logBucket) {
    return _c('div', {
      key: logBucket.id,
      staticClass: "log-bucket"
    }, _vm._l((logBucket.logs.map(function (x) { return JSON.parse(x); })), function(log) {
      return _c('div', {
        staticClass: "log-message",
        class: 'log-type-' + log.type
      }, [_c('span', {
        staticClass: "log-timestamp"
      }, [_vm._v("\n            " + _vm._s(_vm.formatTimestamp(log.timestamp)) + "\n          ")]), _vm._v(" "), _c('span', {
        staticClass: "log-content"
      }, [_c('span', [_vm._v(_vm._s(log.type) + ":")]), _vm._v(" "), _vm._l((log.message), function(part) {
        return _c('span', [_vm._v("\n              " + _vm._s(part) + "\n            ")])
      }), _vm._v(" "), (log.type == 'timer') ? _c('span', [_vm._v("\n              " + _vm._s(log.label) + " " + _vm._s(log.time) + "ms\n            ")]) : _vm._e(), _vm._v(" "), (log.trace) ? _c('div', [_vm._v(_vm._s(log.trace))]) : _vm._e()], 2)])
    }))
  }))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', {
    staticClass: "mdl-layout-title"
  }, [_vm._v("Log Viewer")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  })])])
}]}

/***/ }),

/***/ 410:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columnTranslation"
  }, [_vm._l((_vm.value), function(translation, index) {
    return _c('div', {
      staticClass: "column"
    }, [_c('div', {
      staticClass: "field mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
    }, [_c('input', {
      ref: 'translation_key_' + translation.from,
      refInFor: true,
      staticClass: "mdl-textfield__input",
      attrs: {
        "type": "text",
        "id": 'translation_key_' + translation.from,
        "required": _vm.required
      },
      domProps: {
        "value": translation.from
      },
      on: {
        "input": function($event) {
          _vm.updateFrom(index, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "mdl-textfield__label",
      attrs: {
        "for": 'translation_key_' + translation.from
      }
    }, [_vm._v("Translate From")])]), _vm._v(" "), _c('SingleSelect', {
      attrs: {
        "value": translation.to,
        "options": _vm.targets
      },
      on: {
        "input": function (value) { return _vm.updateTo(index, value); }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent del-translation",
      on: {
        "click": function($event) {
          _vm.deleteTranslation(index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete_forever")])]), _vm._v(" "), (_vm.errors[index]) ? _c('div', {
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.errors[index]))]) : _vm._e()], 1)
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent add-translation",
    on: {
      "click": _vm.addTranslation
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 411:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.loggedIn) ? _c('div', {
    staticClass: "demo-layout mdl-layout mdl-layout--fixed-drawer mdl-layout--fixed-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "demo-drawer mdl-layout__drawer mdl-color--blue-grey-900 mdl-color-text--blue-grey-50",
    class: {
      'is-visible': _vm.drawerVisible
    },
    attrs: {
      "id": "main-drawer"
    }
  }, [_vm._m(1), _vm._v(" "), _c('nav', {
    staticClass: "demo-navigation mdl-navigation mdl-color--blue-grey-800"
  }, [_vm._m(2), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("people")]), _vm._v("\n          Users\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": {
        name: 'logs'
      }
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("list")]), _vm._v("\n          Logs\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": {
        name: 'inputFields'
      }
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("table_chart")]), _vm._v("\n          Input Fields\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  }), _vm._v(" "), _c('a', {
    staticClass: "mdl-navigation__link",
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("exit_to_app")]), _vm._v("Sign out")]), _vm._v(" "), _vm._m(3)], 1)]), _vm._v(" "), _c('main', {
    staticClass: "mdl-layout__content mdl-color--grey-100"
  }, [_c('button', {
    staticClass: "drawer-button",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.showDrawer
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', [_c('router-view')], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.loggedIn) ? _c('div', [_c('LoginForm')], 1) : _vm._e(), _vm._v(" "), _c('overlay-component', {
    attrs: {
      "overlayModel": _vm.overlayModel
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "demo-drawer-header"
  }, [_c('img', {
    staticClass: "demo-avatar",
    attrs: {
      "src": "/static/images/voleadstools2_mid.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "demo-avatar-dropdown"
  }, [_c('span', [_vm._v("Control panel")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-js-ripple-effect mdl-button--icon",
    attrs: {
      "id": "accbtn"
    }
  }, [_c('i', {
    staticClass: "material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("arrow_drop_down")]), _vm._v(" "), _c('span', {
    staticClass: "visuallyhidden"
  }, [_vm._v("AdTools")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("home")]), _vm._v("\n          Home\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', {
    staticClass: "visuallyhidden"
  }, [_vm._v("Help")])])
}]}

/***/ }),

/***/ 412:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "country-input",
    on: {
      "click": _vm.showPrefixMenu
    }
  }, [_c('div', {
    ref: "country",
    staticClass: "mdl-textfield mdl-textfield--floating-label is-upgraded",
    class: {
      'is-invalid': _vm.invalid || (_vm.required && _vm.empty),
        'is-dirty': !_vm.empty
    }
  }, [_c('span', {
    staticClass: "value mdl-textfield__input"
  }, [(!_vm.empty) ? _c('span', {
    staticClass: "countryFlag flag-icon",
    class: 'flag-icon-' + (_vm.liveValue.toLowerCase())
  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.name) + "  \n    ")]), _vm._v(" "), _c('span', {
    staticClass: "mdl-textfield__label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "more"
  }, [_c('span', [_vm._v("▾")])])
}]}

/***/ }),

/***/ 413:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "single-select",
    attrs: {
      "id": 'multiselect-' + _vm.uniq
    }
  }, [_c('button', {
    ref: "button",
    staticClass: "nice-select",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleMenu()
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.visibleValue)), _c('span', [_vm._v("▾")])])])
},staticRenderFns: []}

/***/ }),

/***/ 414:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "phone-input"
  }, [_c('div', {
    ref: "prefix",
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield prefix",
    class: {
      'is-invalid': _vm.prefixInvalid
    },
    on: {
      "click": _vm.showPrefixMenu
    }
  }, [_c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.prefix.length > 0 ? _vm.prefix : "+??"))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield mdl-textfield--floating-label number"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }],
    ref: "number",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "number",
      "required": _vm.required,
      "pattern": "[0-9 #+-]{3,}"
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "number"
    }
  }, [_vm._v(_vm._s(_vm.label))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "more"
  }, [_c('span', [_vm._v("▾")])])
}]}

/***/ }),

/***/ 415:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inputLanguage"
  }, [_c('header', {
    staticClass: "demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', {
    staticClass: "mdl-layout-title"
  }, [_vm._v("Input Language " + _vm._s(_vm.$route.params.name))]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  })])]), _vm._v(" "), (!_vm.language) ? _c('div', {
    staticClass: "loading-holder"
  }, [_c('h3', [_vm._v("Loading Data...")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-progress mdl-js-progress mdl-progress__indeterminate"
  }), _vm._v(" "), _c('h4', [_vm._v("Please wait!")])]) : _vm._e(), _vm._v(" "), (_vm.language) ? _c('div', {
    staticClass: "input-language-card mdl-card mdl-shadow--2dp",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, _vm._l((Object.keys(_vm.translationTargets)), function(inputType) {
    return _c('div', {
      staticClass: "translationTarget"
    }, [_c('h4', [_vm._v(_vm._s(inputType))]), _vm._v(" "), _c('h6', [_vm._v("Columns")]), _vm._v(" "), _c('ColumnTranslation', {
      attrs: {
        "targets": _vm.translationTargets[inputType]
      },
      model: {
        value: (_vm.config[inputType].columnTranslation),
        callback: function($$v) {
          _vm.$set(_vm.config[inputType], "columnTranslation", $$v)
        },
        expression: "config[inputType].columnTranslation"
      }
    }), _vm._v(" "), _c('h6', [_vm._v("Summary Lines")]), _vm._v(" "), _c('SummaryRegex', {
      model: {
        value: (_vm.config[inputType].summaryRegex),
        callback: function($$v) {
          _vm.$set(_vm.config[inputType], "summaryRegex", $$v)
        },
        expression: "config[inputType].summaryRegex"
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--border"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")]), _vm._v("\n          Save\n        ")])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 416:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "country-picker"
  }, [_c('overlay-anchor', {
    attrs: {
      "anchor": _vm.anchor,
      "directions": _vm.directions
    },
    on: {
      "positioned": _vm.updatePosition
    }
  }, [_c('div', {
    staticClass: "prefix-box mdl-card mdl-shadow--2dp",
    style: ({
      'max-width': (_vm.windowDimmensions.width - _vm.position.x - 5) + 'px',
      'max-height': (_vm.windowDimmensions.height - _vm.position.y - 5) + 'px'
    }),
    attrs: {
      "ef": "box"
    }
  }, [_c('div', {
    staticClass: "mdl-card__supporting-text search-panel"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "search",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "search"
    }
  }, [_vm._v("Country search")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text countries"
  }, _vm._l((_vm.filteredCountries), function(country) {
    return _c('div', {
      staticClass: "country",
      on: {
        "click": function($event) {
          _vm.countrySelected(country)
        }
      }
    }, [_c('span', {
      staticClass: "countryFlag flag-icon",
      class: 'flag-icon-' + (country.code.toLowerCase())
    }), _vm._v(" "), _c('span', {
      staticClass: "countryName"
    }, [_vm._v(_vm._s(country.name))])])
  }))])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 417:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "InputLanguages"
  }, [(!_vm.languages) ? _c('div', {
    staticClass: "loading-holder"
  }, [_c('h3', [_vm._v("Loading Data...")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-progress mdl-js-progress mdl-progress__indeterminate"
  }), _vm._v(" "), _c('h4', [_vm._v("Please wait!")])]) : _vm._e(), _vm._v(" "), (_vm.languages) ? _c('div', {
    staticClass: "input-languages-card mdl-card mdl-shadow--2dp",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [(!_vm.deleting) ? _c('div', {
    staticClass: "languages-list list"
  }, _vm._l((_vm.languages), function(file) {
    return _c('div', {
      staticClass: "file"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'inputLanguage',
          params: {
            name: file.name
          }
        }
      }
    }, [(_vm.renaming != file) ? _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(file.name))]) : _vm._e()]), _vm._v(" "), (!_vm.renaming && !_vm.deleting) ? _c('span', {
      staticClass: "buttons"
    }, [_c('span', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.remove(file)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete_forever")])]), _vm._v(" "), _c('span', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.rename(file)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("create")])])]) : _vm._e(), _vm._v(" "), (_vm.renaming == file) ? _c('span', {
      staticClass: "rename"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newName),
        expression: "newName"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newName = $event.target.value
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.renaming == file) ? _c('span', {
      staticClass: "buttons"
    }, [_c('span', {
      staticClass: "btn",
      on: {
        "click": _vm.finishRename
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("done")])])]) : _vm._e()], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.deleting) ? _c('div', {
    staticClass: "deleteDialog"
  }, [_c('p', [_vm._v("\n          Do you really want to delete language " + _vm._s(_vm.deleting.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "yesno"
  }, [_c('span', {
    staticClass: "btn mdl-button mdl-js-button mdl-button--raised mdl-button--accent",
    on: {
      "click": _vm.confirmDelete
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('span', {
    staticClass: "btn mdl-button mdl-js-button mdl-button--raised mdl-button--colored",
    on: {
      "lick": _vm.cancelDelete
    }
  }, [_vm._v("No")])])]) : _vm._e()]), _vm._v(" "), (!_vm.deleting) ? _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--border"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newLanguageCode),
      expression: "newLanguageCode"
    }],
    ref: "fileName",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "fileName",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.newLanguageCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newLanguageCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "fileName"
    }
  }, [_vm._v("Language code")])]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.addLanguage
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v("\n        Add Language\n      ")])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Input Languages")])])
}]}

/***/ }),

/***/ 418:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "phone-prefix-picker"
  }, [_c('overlay-anchor', {
    attrs: {
      "anchor": _vm.anchor,
      "directions": _vm.directions
    },
    on: {
      "positioned": _vm.updatePosition
    }
  }, [_c('div', {
    staticClass: "prefix-box mdl-card mdl-shadow--2dp",
    style: ({
      'max-width': (_vm.windowDimmensions.width - _vm.position.x - 5) + 'px',
      'max-height': (_vm.windowDimmensions.height - _vm.position.y - 5) + 'px'
    }),
    attrs: {
      "ef": "box"
    }
  }, [_c('div', {
    staticClass: "mdl-card__supporting-text search-panel"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "search",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "search"
    }
  }, [_vm._v("Country search")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text countries"
  }, _vm._l((_vm.filteredCountries), function(country) {
    return _c('div', {
      staticClass: "country",
      on: {
        "click": function($event) {
          _vm.countrySelected(country)
        }
      }
    }, [_c('span', {
      staticClass: "countryFlag flag-icon",
      class: 'flag-icon-' + (country.code.toLowerCase())
    }), _vm._v(" "), _c('span', {
      staticClass: "countryPrefix"
    }, [_vm._v(_vm._s(country.dial_code))]), _vm._v(" "), _c('span', {
      staticClass: "countryName"
    }, [_vm._v(_vm._s(country.name))])])
  }))])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 419:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-form"
  }, [_c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_c('div', {
    staticClass: "error"
  }, [(_vm.error) ? _c('span', [_vm._v(_vm._s(_vm.error))]) : _vm._e()]), _vm._v(" "), _c('form', {
    class: {
      blurred: _vm.state == 'working'
    },
    on: {
      "submit": _vm.login
    }
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "email",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "email",
      "id": "email",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "password",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "password",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")])]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          Sign In\n        ")])]), _vm._v(" "), (_vm.state == 'working') ? _c('div', {
    staticClass: "working"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  })]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__title mdl-card-colo"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Sign In")])])
}]}

/***/ }),

/***/ 420:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "multiSelectPicker"
  }, [_c('overlay-anchor', {
    attrs: {
      "anchor": _vm.anchor,
      "directions": _vm.directions
    },
    on: {
      "positioned": _vm.updatePosition
    }
  }, [_c('div', {
    staticClass: "overlay",
    style: ({
      'max-width': (_vm.windowDimmensions.width - _vm.position.x - 5) + 'px',
      'max-height': (_vm.windowDimmensions.height - _vm.position.y - 5) + 'px'
    })
  }, [_c('ul', {}, _vm._l((_vm.visibleOptions), function(option, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.set(option)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.display(option)))])])
  }))])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 421:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "users"
  }, [_vm._m(0), _vm._v(" "), (!_vm.usersList) ? _c('div', {
    staticClass: "loading-holder"
  }, [_c('h3', [_vm._v("Loading Data...")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-progress mdl-js-progress mdl-progress__indeterminate"
  }), _vm._v(" "), _c('h4', [_vm._v("Please wait!")])]) : _vm._e(), _vm._v(" "), (_vm.usersList) ? _c('div', {
    staticClass: "users-card mdl-card mdl-shadow--2dp",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('div', {
    staticClass: "mdl-card__supporting-text search"
  }, [_c('i', {
    staticClass: "material-icons searchIcon"
  }, [_vm._v("search")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "search"
    }
  }, [_vm._v("Search...")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_c('div', {
    staticClass: "users-list"
  }, _vm._l((_vm.filteredUsersList), function(user) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: 'user',
          params: {
            userId: user.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "material-icons user-icon"
    }, [_vm._v("person")]), _vm._v(" "), _c('span', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(user.display))])])], 1)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.addUser
    }
  }, [_vm._v("\n        Add empty user\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.openAddEmailPasswordDialog
    }
  }, [_vm._v("\n        Add user with email and password\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.addEmailPasswordDialog) ? _c('div', {
    staticClass: "dialog-holder"
  }, [_c('div', {
    staticClass: "dialog mdl-card mdl-shadow--4dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--accent"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Change password")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": function () { return _vm.addEmailPasswordDialog = false; }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield&#45;&#45;floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmail),
      expression: "newEmail"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "email",
      "id": "email"
    },
    domProps: {
      "value": (_vm.newEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("New email")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield&#45;&#45;floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "pass2"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "pass2"
    }
  }, [_vm._v("New password")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border",
    class: {
      blurred: _vm.state == 'saving'
    }
  }, [_c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": function () { return _vm.addEmailPasswordDialog = false; }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.addEmailPassword
    }
  }, [_vm._v("\n          Add email/password\n        ")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', {
    staticClass: "mdl-layout-title"
  }, [_vm._v("Users")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  })])])
}]}

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summaryRegex"
  }, [_vm._l((_vm.value), function(regex, index) {
    return _c('div', [_c('div', {
      staticClass: "field mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
    }, [_c('input', {
      ref: 'summary_' + index,
      refInFor: true,
      staticClass: "mdl-textfield__input",
      attrs: {
        "type": "text",
        "id": 'summary_' + index,
        "required": _vm.required
      },
      domProps: {
        "value": regex
      },
      on: {
        "input": function($event) {
          _vm.updateRegex(index, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "mdl-textfield__label",
      attrs: {
        "for": 'summary_' + index
      }
    }, [_vm._v("Summary regex")])]), _vm._v(" "), _c('button', {
      staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent del-regex",
      on: {
        "click": function($event) {
          _vm.deleteRegex(index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete_forever")])]), _vm._v(" "), (_vm.errors[index]) ? _c('div', {
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.errors[index]))]) : _vm._e()])
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent add-regex",
    on: {
      "click": _vm.addRegex
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 423:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inputFields"
  }, [_vm._m(0), _vm._v(" "), _c('InputLanguages')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', {
    staticClass: "mdl-layout-title"
  }, [_vm._v("Input Fields")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  })])])
}]}

/***/ }),

/***/ 424:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logs"
  }, [_vm._m(0), _vm._v(" "), (!_vm.logs) ? _c('div', {
    staticClass: "loading-holder"
  }, [_c('h3', [_vm._v("Loading Data...")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-progress mdl-js-progress mdl-progress__indeterminate"
  }), _vm._v(" "), _c('h4', [_vm._v("Please wait!")])]) : _vm._e(), _vm._v(" "), (_vm.logs) ? _c('div', {
    staticClass: "logs-card mdl-card mdl-shadow--2dp",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_c('div', {
    staticClass: "logs-list"
  }, [_c('ul', _vm._l((_vm.logs), function(log) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'log',
          params: {
            logId: log.logId
          }
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.formatTime(log.date)))]), _vm._v(":\n              "), _c('span', [_vm._v(_vm._s(log.ip))])])], 1)
  }))])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', {
    staticClass: "mdl-layout-title"
  }, [_vm._v("logs")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  })])])
}]}

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  "name": "Afghanistan",
  "dial_code": "+93",
  "code": "AF"
}, {
  "name": "Aland Islands",
  "dial_code": "+358",
  "code": "AX"
}, {
  "name": "Albania",
  "dial_code": "+355",
  "code": "AL"
}, {
  "name": "Algeria",
  "dial_code": "+213",
  "code": "DZ"
}, {
  "name": "AmericanSamoa",
  "dial_code": "+1684",
  "code": "AS"
}, {
  "name": "Andorra",
  "dial_code": "+376",
  "code": "AD"
}, {
  "name": "Angola",
  "dial_code": "+244",
  "code": "AO"
}, {
  "name": "Anguilla",
  "dial_code": "+1264",
  "code": "AI"
}, {
  "name": "Antarctica",
  "dial_code": "+672",
  "code": "AQ"
}, {
  "name": "Antigua and Barbuda",
  "dial_code": "+1268",
  "code": "AG"
}, {
  "name": "Argentina",
  "dial_code": "+54",
  "code": "AR"
}, {
  "name": "Armenia",
  "dial_code": "+374",
  "code": "AM"
}, {
  "name": "Aruba",
  "dial_code": "+297",
  "code": "AW"
}, {
  "name": "Australia",
  "dial_code": "+61",
  "code": "AU"
}, {
  "name": "Austria",
  "dial_code": "+43",
  "code": "AT"
}, {
  "name": "Azerbaijan",
  "dial_code": "+994",
  "code": "AZ"
}, {
  "name": "Bahamas",
  "dial_code": "+1242",
  "code": "BS"
}, {
  "name": "Bahrain",
  "dial_code": "+973",
  "code": "BH"
}, {
  "name": "Bangladesh",
  "dial_code": "+880",
  "code": "BD"
}, {
  "name": "Barbados",
  "dial_code": "+1246",
  "code": "BB"
}, {
  "name": "Belarus",
  "dial_code": "+375",
  "code": "BY"
}, {
  "name": "Belgium",
  "dial_code": "+32",
  "code": "BE"
}, {
  "name": "Belize",
  "dial_code": "+501",
  "code": "BZ"
}, {
  "name": "Benin",
  "dial_code": "+229",
  "code": "BJ"
}, {
  "name": "Bermuda",
  "dial_code": "+1441",
  "code": "BM"
}, {
  "name": "Bhutan",
  "dial_code": "+975",
  "code": "BT"
}, {
  "name": "Bolivia, Plurinational State of bolivia",
  "dial_code": "+591",
  "code": "BO"
}, {
  "name": "Bosnia and Herzegovina",
  "dial_code": "+387",
  "code": "BA"
}, {
  "name": "Botswana",
  "dial_code": "+267",
  "code": "BW"
}, {
  "name": "Brazil",
  "dial_code": "+55",
  "code": "BR"
}, {
  "name": "British Indian Ocean Territory",
  "dial_code": "+246",
  "code": "IO"
}, {
  "name": "Brunei Darussalam",
  "dial_code": "+673",
  "code": "BN"
}, {
  "name": "Bulgaria",
  "dial_code": "+359",
  "code": "BG"
}, {
  "name": "Burkina Faso",
  "dial_code": "+226",
  "code": "BF"
}, {
  "name": "Burundi",
  "dial_code": "+257",
  "code": "BI"
}, {
  "name": "Cambodia",
  "dial_code": "+855",
  "code": "KH"
}, {
  "name": "Cameroon",
  "dial_code": "+237",
  "code": "CM"
}, {
  "name": "Canada",
  "dial_code": "+1",
  "code": "CA"
}, {
  "name": "Cape Verde",
  "dial_code": "+238",
  "code": "CV"
}, {
  "name": "Cayman Islands",
  "dial_code": "+ 345",
  "code": "KY"
}, {
  "name": "Central African Republic",
  "dial_code": "+236",
  "code": "CF"
}, {
  "name": "Chad",
  "dial_code": "+235",
  "code": "TD"
}, {
  "name": "Chile",
  "dial_code": "+56",
  "code": "CL"
}, {
  "name": "China",
  "dial_code": "+86",
  "code": "CN"
}, {
  "name": "Christmas Island",
  "dial_code": "+61",
  "code": "CX"
}, {
  "name": "Cocos (Keeling) Islands",
  "dial_code": "+61",
  "code": "CC"
}, {
  "name": "Colombia",
  "dial_code": "+57",
  "code": "CO"
}, {
  "name": "Comoros",
  "dial_code": "+269",
  "code": "KM"
}, {
  "name": "Congo",
  "dial_code": "+242",
  "code": "CG"
}, {
  "name": "Congo, The Democratic Republic of the Congo",
  "dial_code": "+243",
  "code": "CD"
}, {
  "name": "Cook Islands",
  "dial_code": "+682",
  "code": "CK"
}, {
  "name": "Costa Rica",
  "dial_code": "+506",
  "code": "CR"
}, {
  "name": "Cote d'Ivoire",
  "dial_code": "+225",
  "code": "CI"
}, {
  "name": "Croatia",
  "dial_code": "+385",
  "code": "HR"
}, {
  "name": "Cuba",
  "dial_code": "+53",
  "code": "CU"
}, {
  "name": "Cyprus",
  "dial_code": "+357",
  "code": "CY"
}, {
  "name": "Czech Republic",
  "dial_code": "+420",
  "code": "CZ"
}, {
  "name": "Denmark",
  "dial_code": "+45",
  "code": "DK"
}, {
  "name": "Djibouti",
  "dial_code": "+253",
  "code": "DJ"
}, {
  "name": "Dominica",
  "dial_code": "+1767",
  "code": "DM"
}, {
  "name": "Dominican Republic",
  "dial_code": "+1849",
  "code": "DO"
}, {
  "name": "Ecuador",
  "dial_code": "+593",
  "code": "EC"
}, {
  "name": "Egypt",
  "dial_code": "+20",
  "code": "EG"
}, {
  "name": "El Salvador",
  "dial_code": "+503",
  "code": "SV"
}, {
  "name": "Equatorial Guinea",
  "dial_code": "+240",
  "code": "GQ"
}, {
  "name": "Eritrea",
  "dial_code": "+291",
  "code": "ER"
}, {
  "name": "Estonia",
  "dial_code": "+372",
  "code": "EE"
}, {
  "name": "Ethiopia",
  "dial_code": "+251",
  "code": "ET"
}, {
  "name": "Falkland Islands (Malvinas)",
  "dial_code": "+500",
  "code": "FK"
}, {
  "name": "Faroe Islands",
  "dial_code": "+298",
  "code": "FO"
}, {
  "name": "Fiji",
  "dial_code": "+679",
  "code": "FJ"
}, {
  "name": "Finland",
  "dial_code": "+358",
  "code": "FI"
}, {
  "name": "France",
  "dial_code": "+33",
  "code": "FR"
}, {
  "name": "French Guiana",
  "dial_code": "+594",
  "code": "GF"
}, {
  "name": "French Polynesia",
  "dial_code": "+689",
  "code": "PF"
}, {
  "name": "Gabon",
  "dial_code": "+241",
  "code": "GA"
}, {
  "name": "Gambia",
  "dial_code": "+220",
  "code": "GM"
}, {
  "name": "Georgia",
  "dial_code": "+995",
  "code": "GE"
}, {
  "name": "Germany",
  "dial_code": "+49",
  "code": "DE"
}, {
  "name": "Ghana",
  "dial_code": "+233",
  "code": "GH"
}, {
  "name": "Gibraltar",
  "dial_code": "+350",
  "code": "GI"
}, {
  "name": "Greece",
  "dial_code": "+30",
  "code": "GR"
}, {
  "name": "Greenland",
  "dial_code": "+299",
  "code": "GL"
}, {
  "name": "Grenada",
  "dial_code": "+1473",
  "code": "GD"
}, {
  "name": "Guadeloupe",
  "dial_code": "+590",
  "code": "GP"
}, {
  "name": "Guam",
  "dial_code": "+1671",
  "code": "GU"
}, {
  "name": "Guatemala",
  "dial_code": "+502",
  "code": "GT"
}, {
  "name": "Guernsey",
  "dial_code": "+44",
  "code": "GG"
}, {
  "name": "Guinea",
  "dial_code": "+224",
  "code": "GN"
}, {
  "name": "Guinea-Bissau",
  "dial_code": "+245",
  "code": "GW"
}, {
  "name": "Guyana",
  "dial_code": "+592",
  "code": "GY"
}, {
  "name": "Haiti",
  "dial_code": "+509",
  "code": "HT"
}, {
  "name": "Holy See (Vatican City State)",
  "dial_code": "+379",
  "code": "VA"
}, {
  "name": "Honduras",
  "dial_code": "+504",
  "code": "HN"
}, {
  "name": "Hong Kong",
  "dial_code": "+852",
  "code": "HK"
}, {
  "name": "Hungary",
  "dial_code": "+36",
  "code": "HU"
}, {
  "name": "Iceland",
  "dial_code": "+354",
  "code": "IS"
}, {
  "name": "India",
  "dial_code": "+91",
  "code": "IN"
}, {
  "name": "Indonesia",
  "dial_code": "+62",
  "code": "ID"
}, {
  "name": "Iran, Islamic Republic of Persian Gulf",
  "dial_code": "+98",
  "code": "IR"
}, {
  "name": "Iraq",
  "dial_code": "+964",
  "code": "IQ"
}, {
  "name": "Ireland",
  "dial_code": "+353",
  "code": "IE"
}, {
  "name": "Isle of Man",
  "dial_code": "+44",
  "code": "IM"
}, {
  "name": "Israel",
  "dial_code": "+972",
  "code": "IL"
}, {
  "name": "Italy",
  "dial_code": "+39",
  "code": "IT"
}, {
  "name": "Jamaica",
  "dial_code": "+1876",
  "code": "JM"
}, {
  "name": "Japan",
  "dial_code": "+81",
  "code": "JP"
}, {
  "name": "Jersey",
  "dial_code": "+44",
  "code": "JE"
}, {
  "name": "Jordan",
  "dial_code": "+962",
  "code": "JO"
}, {
  "name": "Kazakhstan",
  "dial_code": "+7",
  "code": "KZ"
}, {
  "name": "Kenya",
  "dial_code": "+254",
  "code": "KE"
}, {
  "name": "Kiribati",
  "dial_code": "+686",
  "code": "KI"
}, {
  "name": "Korea, Democratic People's Republic of Korea",
  "dial_code": "+850",
  "code": "KP"
}, {
  "name": "Korea, Republic of South Korea",
  "dial_code": "+82",
  "code": "KR"
}, {
  "name": "Kuwait",
  "dial_code": "+965",
  "code": "KW"
}, {
  "name": "Kyrgyzstan",
  "dial_code": "+996",
  "code": "KG"
}, {
  "name": "Laos",
  "dial_code": "+856",
  "code": "LA"
}, {
  "name": "Latvia",
  "dial_code": "+371",
  "code": "LV"
}, {
  "name": "Lebanon",
  "dial_code": "+961",
  "code": "LB"
}, {
  "name": "Lesotho",
  "dial_code": "+266",
  "code": "LS"
}, {
  "name": "Liberia",
  "dial_code": "+231",
  "code": "LR"
}, {
  "name": "Libyan Arab Jamahiriya",
  "dial_code": "+218",
  "code": "LY"
}, {
  "name": "Liechtenstein",
  "dial_code": "+423",
  "code": "LI"
}, {
  "name": "Lithuania",
  "dial_code": "+370",
  "code": "LT"
}, {
  "name": "Luxembourg",
  "dial_code": "+352",
  "code": "LU"
}, {
  "name": "Macao",
  "dial_code": "+853",
  "code": "MO"
}, {
  "name": "Macedonia",
  "dial_code": "+389",
  "code": "MK"
}, {
  "name": "Madagascar",
  "dial_code": "+261",
  "code": "MG"
}, {
  "name": "Malawi",
  "dial_code": "+265",
  "code": "MW"
}, {
  "name": "Malaysia",
  "dial_code": "+60",
  "code": "MY"
}, {
  "name": "Maldives",
  "dial_code": "+960",
  "code": "MV"
}, {
  "name": "Mali",
  "dial_code": "+223",
  "code": "ML"
}, {
  "name": "Malta",
  "dial_code": "+356",
  "code": "MT"
}, {
  "name": "Marshall Islands",
  "dial_code": "+692",
  "code": "MH"
}, {
  "name": "Martinique",
  "dial_code": "+596",
  "code": "MQ"
}, {
  "name": "Mauritania",
  "dial_code": "+222",
  "code": "MR"
}, {
  "name": "Mauritius",
  "dial_code": "+230",
  "code": "MU"
}, {
  "name": "Mayotte",
  "dial_code": "+262",
  "code": "YT"
}, {
  "name": "Mexico",
  "dial_code": "+52",
  "code": "MX"
}, {
  "name": "Micronesia, Federated States of Micronesia",
  "dial_code": "+691",
  "code": "FM"
}, {
  "name": "Moldova",
  "dial_code": "+373",
  "code": "MD"
}, {
  "name": "Monaco",
  "dial_code": "+377",
  "code": "MC"
}, {
  "name": "Mongolia",
  "dial_code": "+976",
  "code": "MN"
}, {
  "name": "Montenegro",
  "dial_code": "+382",
  "code": "ME"
}, {
  "name": "Montserrat",
  "dial_code": "+1664",
  "code": "MS"
}, {
  "name": "Morocco",
  "dial_code": "+212",
  "code": "MA"
}, {
  "name": "Mozambique",
  "dial_code": "+258",
  "code": "MZ"
}, {
  "name": "Myanmar",
  "dial_code": "+95",
  "code": "MM"
}, {
  "name": "Namibia",
  "dial_code": "+264",
  "code": "NA"
}, {
  "name": "Nauru",
  "dial_code": "+674",
  "code": "NR"
}, {
  "name": "Nepal",
  "dial_code": "+977",
  "code": "NP"
}, {
  "name": "Netherlands",
  "dial_code": "+31",
  "code": "NL"
}, {
  "name": "Netherlands Antilles",
  "dial_code": "+599",
  "code": "AN"
}, {
  "name": "New Caledonia",
  "dial_code": "+687",
  "code": "NC"
}, {
  "name": "New Zealand",
  "dial_code": "+64",
  "code": "NZ"
}, {
  "name": "Nicaragua",
  "dial_code": "+505",
  "code": "NI"
}, {
  "name": "Niger",
  "dial_code": "+227",
  "code": "NE"
}, {
  "name": "Nigeria",
  "dial_code": "+234",
  "code": "NG"
}, {
  "name": "Niue",
  "dial_code": "+683",
  "code": "NU"
}, {
  "name": "Norfolk Island",
  "dial_code": "+672",
  "code": "NF"
}, {
  "name": "Northern Mariana Islands",
  "dial_code": "+1670",
  "code": "MP"
}, {
  "name": "Norway",
  "dial_code": "+47",
  "code": "NO"
}, {
  "name": "Oman",
  "dial_code": "+968",
  "code": "OM"
}, {
  "name": "Pakistan",
  "dial_code": "+92",
  "code": "PK"
}, {
  "name": "Palau",
  "dial_code": "+680",
  "code": "PW"
}, {
  "name": "Palestinian Territory, Occupied",
  "dial_code": "+970",
  "code": "PS"
}, {
  "name": "Panama",
  "dial_code": "+507",
  "code": "PA"
}, {
  "name": "Papua New Guinea",
  "dial_code": "+675",
  "code": "PG"
}, {
  "name": "Paraguay",
  "dial_code": "+595",
  "code": "PY"
}, {
  "name": "Peru",
  "dial_code": "+51",
  "code": "PE"
}, {
  "name": "Philippines",
  "dial_code": "+63",
  "code": "PH"
}, {
  "name": "Pitcairn",
  "dial_code": "+64",
  "code": "PN"
}, {
  "name": "Poland",
  "dial_code": "+48",
  "code": "PL"
}, {
  "name": "Portugal",
  "dial_code": "+351",
  "code": "PT"
}, {
  "name": "Puerto Rico",
  "dial_code": "+1939",
  "code": "PR"
}, {
  "name": "Qatar",
  "dial_code": "+974",
  "code": "QA"
}, {
  "name": "Romania",
  "dial_code": "+40",
  "code": "RO"
}, {
  "name": "Russia",
  "dial_code": "+7",
  "code": "RU"
}, {
  "name": "Rwanda",
  "dial_code": "+250",
  "code": "RW"
}, {
  "name": "Reunion",
  "dial_code": "+262",
  "code": "RE"
}, {
  "name": "Saint Barthelemy",
  "dial_code": "+590",
  "code": "BL"
}, {
  "name": "Saint Helena, Ascension and Tristan Da Cunha",
  "dial_code": "+290",
  "code": "SH"
}, {
  "name": "Saint Kitts and Nevis",
  "dial_code": "+1869",
  "code": "KN"
}, {
  "name": "Saint Lucia",
  "dial_code": "+1758",
  "code": "LC"
}, {
  "name": "Saint Martin",
  "dial_code": "+590",
  "code": "MF"
}, {
  "name": "Saint Pierre and Miquelon",
  "dial_code": "+508",
  "code": "PM"
}, {
  "name": "Saint Vincent and the Grenadines",
  "dial_code": "+1784",
  "code": "VC"
}, {
  "name": "Samoa",
  "dial_code": "+685",
  "code": "WS"
}, {
  "name": "San Marino",
  "dial_code": "+378",
  "code": "SM"
}, {
  "name": "Sao Tome and Principe",
  "dial_code": "+239",
  "code": "ST"
}, {
  "name": "Saudi Arabia",
  "dial_code": "+966",
  "code": "SA"
}, {
  "name": "Senegal",
  "dial_code": "+221",
  "code": "SN"
}, {
  "name": "Serbia",
  "dial_code": "+381",
  "code": "RS"
}, {
  "name": "Seychelles",
  "dial_code": "+248",
  "code": "SC"
}, {
  "name": "Sierra Leone",
  "dial_code": "+232",
  "code": "SL"
}, {
  "name": "Singapore",
  "dial_code": "+65",
  "code": "SG"
}, {
  "name": "Slovakia",
  "dial_code": "+421",
  "code": "SK"
}, {
  "name": "Slovenia",
  "dial_code": "+386",
  "code": "SI"
}, {
  "name": "Solomon Islands",
  "dial_code": "+677",
  "code": "SB"
}, {
  "name": "Somalia",
  "dial_code": "+252",
  "code": "SO"
}, {
  "name": "South Africa",
  "dial_code": "+27",
  "code": "ZA"
}, {
  "name": "South Sudan",
  "dial_code": "+211",
  "code": "SS"
}, {
  "name": "South Georgia and the South Sandwich Islands",
  "dial_code": "+500",
  "code": "GS"
}, {
  "name": "Spain",
  "dial_code": "+34",
  "code": "ES"
}, {
  "name": "Sri Lanka",
  "dial_code": "+94",
  "code": "LK"
}, {
  "name": "Sudan",
  "dial_code": "+249",
  "code": "SD"
}, {
  "name": "Suriname",
  "dial_code": "+597",
  "code": "SR"
}, {
  "name": "Svalbard and Jan Mayen",
  "dial_code": "+47",
  "code": "SJ"
}, {
  "name": "Swaziland",
  "dial_code": "+268",
  "code": "SZ"
}, {
  "name": "Sweden",
  "dial_code": "+46",
  "code": "SE"
}, {
  "name": "Switzerland",
  "dial_code": "+41",
  "code": "CH"
}, {
  "name": "Syrian Arab Republic",
  "dial_code": "+963",
  "code": "SY"
}, {
  "name": "Taiwan",
  "dial_code": "+886",
  "code": "TW"
}, {
  "name": "Tajikistan",
  "dial_code": "+992",
  "code": "TJ"
}, {
  "name": "Tanzania, United Republic of Tanzania",
  "dial_code": "+255",
  "code": "TZ"
}, {
  "name": "Thailand",
  "dial_code": "+66",
  "code": "TH"
}, {
  "name": "Timor-Leste",
  "dial_code": "+670",
  "code": "TL"
}, {
  "name": "Togo",
  "dial_code": "+228",
  "code": "TG"
}, {
  "name": "Tokelau",
  "dial_code": "+690",
  "code": "TK"
}, {
  "name": "Tonga",
  "dial_code": "+676",
  "code": "TO"
}, {
  "name": "Trinidad and Tobago",
  "dial_code": "+1868",
  "code": "TT"
}, {
  "name": "Tunisia",
  "dial_code": "+216",
  "code": "TN"
}, {
  "name": "Turkey",
  "dial_code": "+90",
  "code": "TR"
}, {
  "name": "Turkmenistan",
  "dial_code": "+993",
  "code": "TM"
}, {
  "name": "Turks and Caicos Islands",
  "dial_code": "+1649",
  "code": "TC"
}, {
  "name": "Tuvalu",
  "dial_code": "+688",
  "code": "TV"
}, {
  "name": "Uganda",
  "dial_code": "+256",
  "code": "UG"
}, {
  "name": "Ukraine",
  "dial_code": "+380",
  "code": "UA"
}, {
  "name": "United Arab Emirates",
  "dial_code": "+971",
  "code": "AE"
}, {
  "name": "United Kingdom",
  "dial_code": "+44",
  "code": "GB"
}, {
  "name": "United States",
  "dial_code": "+1",
  "code": "US"
}, {
  "name": "Uruguay",
  "dial_code": "+598",
  "code": "UY"
}, {
  "name": "Uzbekistan",
  "dial_code": "+998",
  "code": "UZ"
}, {
  "name": "Vanuatu",
  "dial_code": "+678",
  "code": "VU"
}, {
  "name": "Venezuela, Bolivarian Republic of Venezuela",
  "dial_code": "+58",
  "code": "VE"
}, {
  "name": "Vietnam",
  "dial_code": "+84",
  "code": "VN"
}, {
  "name": "Virgin Islands, British",
  "dial_code": "+1284",
  "code": "VG"
}, {
  "name": "Virgin Islands, U.S.",
  "dial_code": "+1340",
  "code": "VI"
}, {
  "name": "Wallis and Futuna",
  "dial_code": "+681",
  "code": "WF"
}, {
  "name": "Yemen",
  "dial_code": "+967",
  "code": "YE"
}, {
  "name": "Zambia",
  "dial_code": "+260",
  "code": "ZM"
}, {
  "name": "Zimbabwe",
  "dial_code": "+263",
  "code": "ZW"
}];

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  adPerformance: {
    columnTranslation: [{ from: 'Clicks', to: 'Clicks' }, { from: 'Impressions', to: 'Impressions' }, { from: 'Cost', to: 'Cost' }, { from: 'Conversions', to: 'Conversions' }, { from: 'All conv. value', to: 'ConversionValue' }, { from: 'Headline', to: 'Headline' }, { from: 'Headline 1', to: 'HeadlinePart1' }, { from: 'Headline 2', to: 'HeadlinePart2' }, { from: 'Headline 3', to: 'HeadlinePart3' }, { from: 'Description line 1', to: 'Description1' }, { from: 'Description line 2', to: 'Description2' }, { from: 'Description', to: 'Description' }, { from: 'Display URL', to: 'DisplayUrl' }, { from: "Final URL", to: "CreativeFinalUrls" }, { from: "Destination URL", to: "CreativeDestinationUrl" }, { from: 'Campaign', to: 'CampaignName' }, { from: 'Ad group', to: 'AdGroupName' }],
    summaryRegex: ["^Total"]
  },
  searchQueryPerformance: {
    columnTranslation: [{ from: 'Clicks', to: 'Clicks' }, { from: 'Impressions', to: 'Impressions' }, { from: 'Cost', to: 'Cost' }, { from: 'Conversions', to: 'Conversions' }, { from: 'All conv. value', to: 'ConversionValue' }, { from: 'Campaign', to: 'CampaignName' }, { from: 'Ad group', to: 'AdGroupName' }, { from: 'Search term', to: 'Query' }],
    summaryRegex: ["^Total"]
  }
};

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  possibleRoles: ['admin', 'basic', 'premium']
};

/***/ })

},[276]);


// WEBPACK FOOTER //
// static/js/app.886135a3727bcbb72d99.js